import { useEffect, useState } from "react";

// ui
import { Box, IconButton, Alert } from "@mui/material";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import CircleIcon from "@mui/icons-material/Circle";

// Table
import { ConstTable } from "../component/Table";

// Bar
import TableTopBar from "../component/TableTopBar";
import SerchSideBar from "../component/SerchSideBar";
import AiChatSideBar from "../component/AiChatSideBar";

// Modal
import { DataDetailModal } from "../component/detail/DataDetailModal";
import { DataEditModal } from "../component/DataEditModal";
import { DataAddModalResult } from "../component/DataAddModalResult";
import { ContractAddModal } from "../component/ContractAddModal";
import { PostCSVModal } from "../component/PostCSVModal";
import { PostCSVContractStatusModal } from "../component/PostCSVContractStatusModal";
import { GetXLSXContractModal } from "../component/GetXLSXContractModal";
import { DataDeleteModal } from "../component/tableFunction/DataDeleteModal";
import { DataCancelModal } from "../component/tableFunction/DataCancelModal";
import { ContractCopyTossUpModal } from "../component/tableFunction/ContractCopyTossUpModal";
import { ContractCopyEntryModal } from "../component/tableFunction/ContractCopyEntryModal";
import { PersonDataDeleteModal } from "../component/tableFunction/PersonDataDeleteModal";
import { ChangeAccountCollaborateModal } from "../component/tableFunction/ChangeAccountCollaborateModal";
import { ColumnSettingModal } from "../component/ColumnSettingModal";

// jotai
import { useSetAtom, useAtomValue } from "jotai";
import { AppAtoms } from "../lib/store";

// API
import {
  getContracts,
  getContract,
  putContract,
  postContract,
  deleteContract,
  cancellContract,
  getCancellSmsOptions,
  getContractProducts,
  getContractCopyTossUpAddBefore,
  getContractCopyEntryBefore,
  postContractShortMessage,
  deletePersonContract,
} from "../api/contract";
import { postTossUp } from "../api/tossUp";
import { getContractServiceContents } from "../api/contractServiceContent";
import {
  getContractCustomerInfos,
  putContractCustomerInfo,
} from "../api/contractCustomerInfo";
import { getContractContractInfos, deleteContractContractInfo } from "../api/contractContractInfo";
import { getOldContract } from "../api/oldContract";
import {
  getSerchCategorys,
  getSerchHighRankCompanys,
  getSerchProducts,
  getSerchAccountSales,
  getSerchSaleCompanys,
  getSerchSaleCompanyGroups,
  getSerchAccountCollaborateCompanys,
  getProductCandidatesEntry,
} from "../api/serch";
import {
  getPresignedPostCSV,
  postPresignedPost,
  getPresignedPostPicture,
  getPostCSVHeader,
} from "../api/presignedURL";
import {
  getScreenColumns,
  getScreenColumnContracts,
  putScreenColumnContracts,
} from "../api/screenColumn";

// InterFace
import { contractTableColumn } from "../config/contract";
import {
  dataDifine,
  subDataDifine,
  EditDataDifine,
} from "../config/dataInterface";

// OtherFunc
import { getFirstYear, getOneYear } from "../lib/other";
import { CONST } from "../config/const";

// 営業アカウント更新取込
const putCSVColumnSaleAccount = [
  "商材名",
  "プラン名",
  "顧客電話番号",
  "申込番号",
  "変更後パートナー",
  "変更後営業アカウント",
];

// 申込番号取込
const putCSVColumnContractNumber = [
  "商材名",
  "プラン名",
  "顧客電話番号",
  "申込番号",
];

// 契約事前一括取込
const postCSVColumnAdminContract = [
  "パートナー",
  "営業アカウント氏名",
  "上位店名",
  "商材名",
  "支払方法",
  "リストID",
  "プラン名",
  "コンテンツ1",
  "コンテンツ2",
  "、",
  "コンテンツ20",
  "キャンペーン1",
  "キャンペーン2",
  "、",
  "キャンペーン10",
  "顧客電話番号",
  "顧客氏名",
  "顧客会社名",
  "申込番号",
  "申込日",
  "開通日",
  "解約日",
  "ステータス",
];
const postCSVColumnAdminContractResult = [
  "パートナー",
  "営業アカウント氏名",
  "上位店名",
  "商材名",
  "支払方法",
  "リストID",
  "プラン名",
  "顧客電話番号",
  "顧客氏名",
  "顧客会社名",
  "申込番号",
];

// 契約一括エントリー
const postCSVColumnEntryContract = [
  "営業アカウント氏名",
  "商材名",
  "支払方法",
  "リストID",
  "プラン名",
  "コンテンツ1",
  "コンテンツ2",
  "、",
  "コンテンツ20",
  "キャンペーン1",
  "キャンペーン2",
  "、",
  "キャンペーン10",
  "商材による質問",
];

const postCSVColumnEntryContractResult = [
  "営業アカウント氏名",
  "商材名",
  "支払方法",
  "リストID",
  "プラン名",
];

// 契約サービス一括変更
const putCSVColumnContractService = [
  "上位店名",
  "商材名",
  "申込番号",
  "顧客電話番号",
  "プラン名",
  "コンテンツ1",
  "コンテンツ2",
  "、",
  "コンテンツ20",
  "キャンペーン1",
  "キャンペーン2",
  "、",
  "キャンペーン10",
];
const putCSVColumnContractServiceResult = [
  "上位店名",
  "商材名",
  "申込番号",
  "顧客電話番号",
  "プラン名",
];

function Contract() {
  const loginUser = useAtomValue(AppAtoms.loginUser);
  const isSmartPhone = useAtomValue(AppAtoms.isSmartPhone);
  const contractScreenColumn = useAtomValue(AppAtoms.contractScreenColumn);
  const setContractScreenColumn = useSetAtom(AppAtoms.contractScreenColumn);
  const setIsLoading = useSetAtom(AppAtoms.isLoading);

  // 各権限毎のヘッダーメニューの編集
  const addDataTypes: { auth: string[]; name: string }[] = [
    { auth: ["パートナー", "営業アカウント"], name: "エントリー" },
  ];
  const addCSVDataTypes: { auth: string[]; name: string }[] = [
    {
      auth: ["マスターアカウント", "スタッフアカウント"],
      name: "運用前契約情報一括CSV取込",
    },
    {
      auth: ["マスターアカウント", "スタッフアカウント"],
      name: "申込番号CSV取込",
    },
    {
      auth: ["マスターアカウント", "スタッフアカウント"],
      name: "契約状況CSV取込",
    },
    {
      auth: ["マスターアカウント", "スタッフアカウント"],
      name: "契約サービスCSV更新取込",
    },
    {
      auth: ["パートナー", "営業アカウント"],
      name: "CSV一括エントリー",
    },
    {
      auth: ["マスターアカウント", "スタッフアカウント", "パートナー"],
      name: "営業アカウント更新CSV取込",
    },
  ];
  const getXLSXDataTypes: { auth: string[]; name: string }[] = [
    {
      auth: [
        "マスターアカウント",
        "スタッフアカウント",
        "パートナー",
        "営業アカウント",
      ],
      name: "エントリー一覧出力",
    },
  ];
  const [addDataNames, setAddDataNames] = useState<string[]>([]);
  const [addDataName, setAddDataName] = useState<string>("");
  const [addCSVDataNames, setAddCSVDataNames] = useState<string[]>([]);
  const [addCSVDataName, setAddCSVDataName] = useState<string>("");
  const [getXLSXDataNames, setGetXLSXDataNames] = useState<string[]>([]);
  const [getXLSXDataName, setGetXLSXDataName] = useState<string>("");
  const [editDatasNames, setEditDatasNames] = useState<string[]>([]);
  const [editDatasName, setEditDatasName] = useState<string>("");

  useEffect(() => {
    let addDataNames: string[] = [];
    let addCSVDataNames: string[] = [];
    let getXLSXDataNames: string[] = [];
    addDataTypes.map((dataType) => {
      if (
        loginUser?.authority &&
        dataType.auth.findIndex(
          (authority) => authority === loginUser.authority,
        ) > -1
      ) {
        addDataNames.push(dataType.name);
      }
    });
    setAddDataNames(addDataNames);
    addCSVDataTypes.map((dataType) => {
      if (
        loginUser?.authority &&
        dataType.auth.findIndex(
          (authority) => authority === loginUser.authority,
        ) > -1
      ) {
        addCSVDataNames.push(dataType.name);
      }
    });
    setAddCSVDataNames(addCSVDataNames);
    getXLSXDataTypes.map((dataType) => {
      if (
        loginUser?.authority &&
        dataType.auth.findIndex(
          (authority) => authority === loginUser.authority,
        ) > -1
      ) {
        getXLSXDataNames.push(dataType.name);
      }
    });
    setGetXLSXDataNames(getXLSXDataNames);
  }, [loginUser]);

  useEffect(() => {
    if (addDataName === "エントリー") {
      setAddData({
        ...addData,
        addStatus: "change_account",
      });
    }
  }, [addDataName]);

  useEffect(() => {
    if (addCSVDataName === "契約状況CSV取込") {
      setPostCSVStatus({
        ...postCSVStatus,
        status: "open",
      });
    }
    if (addCSVDataName === "契約サービスCSV更新取込") {
      setPutCSVContractService({
        ...putCSVContractService,
        status: "open",
      });
    }
    if (addCSVDataName === "営業アカウント更新CSV取込") {
      setPostCSVSaleAccount({
        status: "open",
        message: "",
        result: [],
        header_location: "None",
      });
    }
    if (addCSVDataName === "申込番号CSV取込") {
      setPostCSVContractNumber({
        status: "open",
        message: "",
        result: [],
        header_location: "None",
      });
    }
    if (addCSVDataName === "運用前契約情報一括CSV取込") {
      setPostContractCSVStatus({
        status: "open",
        message: "",
        result: [],
        header_location: "None",
      });
    }
    if (addCSVDataName === "CSV一括エントリー") {
      setPostEntryContractCSVStatus({
        status: "open",
        message: "",
        result: [],
        header_location: "None",
      });
    }
  }, [addCSVDataName]);

  useEffect(() => {
    if (getXLSXDataName === "エントリー一覧出力") {
      setGetXLSXStatus({
        ...getXLSXStatus,
        status: "open",
      });
    }
  }, [getXLSXDataName]);

  // サブテーブルデータの一覧取得
  const [getSubTableName, setGetSubTableName] = useState<{
    name: string;
    key: { [key: string]: string };
    subData: subDataDifine[];
  }>({
    name: "",
    key: {},
    subData: [],
  });
  useEffect(() => {
    if (getSubTableName.name === "コンテンツ一覧") {
      getSubtableDataContractServiceContent();
    }
    if (getSubTableName.name === "顧客情報一覧") {
      getSubtableDataContractCustomerInfo();
    }
    if (getSubTableName.name === "契約情報一覧") {
      getSubtableDataContractContractInfo();
    }
  }, [getSubTableName.name, getSubTableName.key]);

  const [tableOriginalFunc, setTableOriginalFunc] = useState<{
    name: string;
    key: { [key: string]: string };
    subTableColumnName?: string;
  }>({
    name: "",
    key: {},
  });
  useEffect(() => {
    if (tableOriginalFunc.name === "トスアップ複製") {
      setEntryToTossUpDataInf({
        ...entryToTossUpDataInf,
        addStatus: "change_account",
      });
    }
    if (tableOriginalFunc.name === "エントリー複製") {
      setEntryToEntryDataInf({
        ...entryToEntryDataInf,
        addStatus: "change_account",
        contractId: tableOriginalFunc.key.id as string,
      });
    }
    if (tableOriginalFunc.name === "エントリー取消") {
      setDeleteDataInf({
        status: "open",
        key: tableOriginalFunc.key,
        message: "",
      });
    }
    if (tableOriginalFunc.name === "解約") {
      const key = tableOriginalFunc.key;
      setCancelDataInf({
        status: "loading",
        key,
        message: "",
        cancellAction: key.cancell_action ?? "",
        cancellSmsList: [],
        selectedCancellSms: null,
        destinationPhoneNumber: "",
        destinationMailAddress: "",
      });
      (async () => {
        const res = await getCancellSmsOptions(key.id);
        setCancelDataInf((prev) =>
          prev.key.id === key.id
            ? {
                ...prev,
                status: "open",
                cancellSmsList: res.cancell_sms_list,
                destinationPhoneNumber: res.destination_phone_number,
                destinationMailAddress: res.destination_mail_address,
              }
            : prev,
        );
      })();
    }
    if (tableOriginalFunc.name === "個人情報削除") {
      setDeletePersonDataInf({
        status: "open",
        key: tableOriginalFunc.key,
        message: "",
      });
    }
    if (
      tableOriginalFunc.name === "削除" &&
      tableOriginalFunc.subTableColumnName === "契約情報一覧"
    ) {
      setDeleteContractInfoDataInf({
        status: "open",
        key: { infoKey: tableOriginalFunc.key.contract_info_key },
        message: "",
      });
    }
  }, [tableOriginalFunc.name, tableOriginalFunc.key, tableOriginalFunc.subTableColumnName]);

  // 検索欄、テーブル等の高さ
  const [tableHeight, setTableHeight] = useState("calc(100vh - 110px)");
  useEffect(() => {
    const tableHeight = isSmartPhone
      ? "calc(100vh - 190px)"
      : "calc(100vh - 110px)";
    setTableHeight(tableHeight);
  }, [isSmartPhone]);
  const [serchOpen, setSerchOpen] = useState(false);
  const [aiChatOpen, setAiChatOpen] = useState(false);

  // 表示数・ページ
  const [displayNumber, setDisplayNumber] = useState(50);
  const displayNumbers = [25, 50, 100, 250, 500];
  const [pageNumber, setPageNumber] = useState(1);
  const [maxPageNumber, setMaxPageNumber] = useState(1);
  const firstYear = getFirstYear();
  const { thisYear, thisMonth, lastYear, lastMonth } = getOneYear();
  const [firstLoading, setFirstLoading] = useState(true);

  // カラムデータの設定
  const [columnSetting, setColumnSetting] = useState<{
    status: "none" | "open" | "loading" | "result" | "error";
    columns: {
      id: number;
      screen_column_auth: 0 | 1;
      screen_column_system_default: 0 | 1;
      table_disabled: 0 | 1;
      screen_column_serch_disabled: 0 | 1;
      detail_disabled: 0 | 1;
      screen_column_name: string;
      screen_column_type: 0 | 1 | 2;
      table_sort: 0 | 1;
      screen_column_table: 0 | 1;
      table_column_size: string;
      screen_column_sort_id: number;
      screen_column_serch: 0 | 1;
      screen_column_detail: 0 | 1;
    }[];
  }>({
    status: "none",
    columns: [],
  });
  useEffect(() => {
    if (columnSetting.status === "loading") {
      setIsLoading(true);
    } else if (columnSetting.status !== "none") {
      setIsLoading(false);
    }
  }, [columnSetting]);

  async function openColumnSettingWindow() {
    setColumnSetting({
      ...columnSetting,
      status: "loading",
    });
    // 既存カラムの取得
    const { fetch_data } = await getScreenColumnContracts();
    setColumnSetting({
      status: "open",
      columns: fetch_data,
    });
  }

  async function putClumnSetting() {
    setColumnSetting({
      ...columnSetting,
      status: "loading",
    });
    const res = await putScreenColumnContracts(columnSetting.columns);
    if (res === "success") {
      setChangeTableData(false);
      setColumnLoading(true);
      await getTableData(true);
      const { contractScreenColumn } = await getScreenColumns();
      setContractScreenColumn(contractScreenColumn);
      setColumnSetting({
        ...columnSetting,
        status: "result",
      });
    } else {
      setColumnSetting({
        ...columnSetting,
        status: "error",
      });
    }
  }

  function closeColumnSettingModal() {
    setColumnSetting({
      status: "none",
      columns: [],
    });
  }

  // テーブルデータ
  const [fetchData, setFetchData] = useState<dataDifine[]>([]);
  const [totalCount, setTotalCount] = useState<number>(0);

  // データ詳細
  const [dataDetail, setDataDetail] = useState<{
    [key: string]: number | string | { [key: string]: string | string[] };
  } | null>(null);

  const [dataDetailOption, setDataDetailOption] = useState<
    { [key: string]: string | number }[]
  >([]);

  const [dataDetailHistory, setDataDetailHistory] = useState<
    { selected_date: string; contract_version: number }[]
  >([]);
  const [selectHistory, setSelectHistory] = useState<number>(0);

  // データ編集
  const [editData, setEditData] = useState<EditDataDifine | null>(null);
  const [selectServiseInfo, setSelectServiseInfo] = useState<{
    service_plan_data: { service_name: string }[];
    service_content_data: { service_name: string }[];
    service_campaign_pulldown_data: { service_name: string }[];
    service_campaign_checkbox_data: { service_name: string }[];
  }>({
    service_plan_data: [],
    service_content_data: [],
    service_campaign_pulldown_data: [],
    service_campaign_checkbox_data: [],
  });
  const [addData, setAddData] = useState<{
    addStatus:
      | null
      | "loading"
      | "change_account"
      | "product"
      | "entry_method"
      | "site_path"
      | "contract"
      | "sms_success";
    outSiteEntry: 0 | 1;
    outsideSiteUrl: string;
    outsideServiceUrl: string;
    viewOutsideServiceUrl: 0 | 1;
    productId: number | null;
    productName: string;
    have_entry_form: number | null;
    site_path_list: string[];
    site_path: string;
    outsideMessageType: number | null;
    phone_number: string;
    customer_name: string;
    customer_company_name: string;
    servicePlanName: string;
    serviceContentNameList: string[];
    serviceCampaignPulldownName: string;
    serviceCampaignCheckboxName: string[];
    servicePaymentMethodName: string;
    serviseCustomerListID: string;
    pullDownServiceName: string;
    checkBoxServiceNames: string;
    smsMessagePatternID: number | null;
    customerInfo: { [key: string]: string | string[] };
    changeAccount: 0 | 1;
    changeAccountID: number | null;
  }>({
    addStatus: null,
    outSiteEntry: 0,
    outsideSiteUrl: "",
    outsideServiceUrl: "",
    viewOutsideServiceUrl: 0,
    productId: null,
    productName: "",
    phone_number: "",
    have_entry_form: null,
    site_path_list: [],
    site_path: "",
    outsideMessageType: null,
    customer_name: "",
    customer_company_name: "",
    servicePlanName: "",
    serviceContentNameList: [],
    serviceCampaignPulldownName: "",
    serviceCampaignCheckboxName: [],
    servicePaymentMethodName: "",
    serviseCustomerListID: "",
    pullDownServiceName: "",
    checkBoxServiceNames: "",
    smsMessagePatternID: null,
    customerInfo: {},
    changeAccount: 0,
    changeAccountID: null,
  });
  // addStatus が loadingのとき
  useEffect(() => {
    if (addData.addStatus === "loading") {
      setIsLoading(true);
    } else if (!firstLoading) {
      setIsLoading(false);
    }
  }, [addData]);

  // 商材一覧取得
  const [contractProductList, setContractProductList] = useState<
    {
      id: number;
      product_name: string;
      have_entry_form: number;
      site_path_list: string[];
    }[]
  >([]);

  async function getContractProductList() {
    setAddData({
      ...addData,
      addStatus: "loading",
    });
    const contractProductList = await getContractProducts(
      addData.changeAccount,
      addData.changeAccountID,
    );
    if (contractProductList) {
      setContractProductList(contractProductList);
      // 製品選択画面に移行
      setAddData({
        ...addData,
        addStatus: "product",
      });
    } else {
      closeAddModal();
      setOnDataAddModalResult(
        "エントリー可能な商材が定義されていません。管理者に問い合わせてください。",
      );
    }
  }
  const [onDataAddModalResult, setOnDataAddModalResult] = useState("");

  // データのトスアップへのコピー
  const [entryToTossUpDataInf, setEntryToTossUpDataInf] = useState<{
    addStatus:
      | null
      | "loading"
      | "change_account"
      | "product"
      | "toss_up"
      | "success"
      | "failed";
    contract_id: string;
    toss_up_id: string;
    category_id_list: number[];
    product_name_list: string[];
    phone_number: string;
    customer_name: string;
    customer_list_id: string;
    hope_call_date: string;
    hope_call_time_kind: number | null;
    hope_call_time: string;
    customerInfo: { [key: string]: string | string[] };
    changeAccount: 0 | 1;
    changeAccountID: number | null;
  }>({
    addStatus: null,
    contract_id: "",
    toss_up_id: "",
    category_id_list: [],
    product_name_list: [],
    phone_number: "",
    customer_name: "",
    customer_list_id: "",
    hope_call_date: "",
    hope_call_time_kind: null,
    hope_call_time: "12-00",
    customerInfo: {},
    changeAccount: 0,
    changeAccountID: null,
  });
  useEffect(() => {
    if (entryToTossUpDataInf.addStatus === "loading") {
      setIsLoading(true);
    } else if (!firstLoading) {
      setIsLoading(false);
    }
  }, [entryToTossUpDataInf]);
  const [tossUpCategoryNameList, setTossUpCategoryNameList] = useState<
    {
      category_id: number;
      category_name: string;
    }[]
  >([]);
  const [tossUpProductNameList, setTossUpProductNameList] = useState<
    {
      category_id: number;
      category_name: string;
      product_name: string;
    }[]
  >([]);
  // 画像データ保持用
  const [entryToTossUpPostPictures, setEntryToTossUpPostPicture] = useState<{
    [key: string]: File;
  }>({});
  const [entryToTossUpUniqueOptinList, setEntryToTossUpUniqueOptinList] =
    useState<{ [key: string]: string | number | string[] }[]>([]);
  const [entryToTossUpAddressOptionName, setEntryToTossUpAddressOptionName] =
    useState("");
  async function openEntryToTossUp() {
    setEntryToTossUpDataInf({
      ...entryToTossUpDataInf,
      addStatus: "loading",
      contract_id: tableOriginalFunc.key.id as string,
    });
    const { tossUpCategoryNameList, tossUpProductNameList, contract_data } =
      await getContractCopyTossUpAddBefore(
        tableOriginalFunc.key.id,
        entryToTossUpDataInf.changeAccount,
        entryToTossUpDataInf.changeAccountID,
      );
    if (tossUpCategoryNameList.length > 0) {
      setTossUpCategoryNameList(tossUpCategoryNameList);
      setTossUpProductNameList(tossUpProductNameList);
      // 製品選択画面に移行
      setEntryToTossUpDataInf({
        ...entryToTossUpDataInf,
        addStatus: "product",
        contract_id: tableOriginalFunc.key.id as string,
        phone_number: contract_data.customer_phone_number as string,
        customer_name: contract_data.customer_name as string,
        customer_list_id: contract_data.customer_list_id as string,
        customerInfo: contract_data.customer_info as {
          [key: string]: string | string[];
        },
      });
    } else {
      closeEntryToTossUpModal();
      setOnDataAddModalResult(
        "トスアップ可能な商材が定義されていません。管理者に問い合わせてください。",
      );
    }
  }
  function closeEntryToTossUpModal() {
    setEntryToTossUpDataInf({
      addStatus: null,
      contract_id: "",
      toss_up_id: "",
      category_id_list: [],
      product_name_list: [],
      phone_number: "",
      customer_name: "",
      customer_list_id: "",
      hope_call_date: "",
      hope_call_time_kind: null,
      hope_call_time: "12-00",
      customerInfo: {},
      changeAccount: 0,
      changeAccountID: null,
    });
    setTossUpCategoryNameList([]);
    setTossUpProductNameList([]);
    setEntryToTossUpPostPicture({});
    setEntryToTossUpUniqueOptinList([]);
    setEntryToTossUpAddressOptionName("");
  }
  async function postEntryToTossUpData(customerInfo: {
    [key: string]: string | string[];
  }) {
    const postResponce = await postTossUp({
      ...entryToTossUpDataInf,
      customerInfo,
    });
    if (postResponce === "success") {
      closeEntryToTossUpModal();
      setOnDataAddModalResult("success");
    } else {
      setOnDataAddModalResult(postResponce);
      setEntryToTossUpDataInf({
        ...entryToTossUpDataInf,
        addStatus: "toss_up",
      });
    }
  }

  const [entryToEntryDataInf, setEntryToEntryDataInf] = useState<{
    addStatus: string;
    contractId: string;
    changeAccount: number;
    changeAccountID: number | null;
    productId: number | null;
    contractData: any[];
    entryProductList: any[];
    beforeOptionData: any[];
    optionData: any[];
    outSiteEntry: 0 | 1;
    site_path: string;
    outsideMessageType: number | null;
    smsMessagePatternID: number | null;
  }>({
    addStatus: "",
    contractId: "",
    changeAccount: 0,
    changeAccountID: null,
    productId: null,
    contractData: [],
    entryProductList: [],
    beforeOptionData: [],
    optionData: [],
    outSiteEntry: 0,
    site_path: "",
    outsideMessageType: null,
    smsMessagePatternID: null,
  });
  useEffect(() => {
    if (entryToEntryDataInf.addStatus === "loading") {
      setIsLoading(true);
    } else if (!firstLoading) {
      setIsLoading(false);
    }
  }, [entryToEntryDataInf]);
  const [customerInfo, setCustomerInfo] = useState<{
    [key: string]: string | string[];
  }>({});
  const [entryToEntryAddData, setEntryToEntryAddData] = useState<{
    addStatus:
      | null
      | "loading"
      | "change_account"
      | "product"
      | "entry_method"
      | "site_path"
      | "contract"
      | "sms_success";
    outSiteEntry: 0 | 1;
    outsideSiteUrl: string;
    outsideServiceUrl: string;
    viewOutsideServiceUrl: 0 | 1;
    productId: number | null;
    productName: string;
    have_entry_form: number | null;
    site_path_list: string[];
    site_path: string;
    outsideMessageType: number | null;
    phone_number: string;
    customer_name: string;
    customer_company_name: string;
    servicePlanName: string;
    serviceContentNameList: string[];
    serviceCampaignPulldownName: string;
    serviceCampaignCheckboxName: string[];
    servicePaymentMethodName: string;
    serviseCustomerListID: string;
    pullDownServiceName: string;
    checkBoxServiceNames: string;
    smsMessagePatternID: number | null;
    customerInfo: { [key: string]: string | string[] };
    changeAccount: 0 | 1;
    changeAccountID: number | null;
  }>({
    addStatus: null,
    outSiteEntry: 0,
    outsideSiteUrl: "",
    outsideServiceUrl: "",
    viewOutsideServiceUrl: 0,
    productId: null,
    productName: "",
    have_entry_form: null,
    site_path_list: [],
    site_path: "",
    outsideMessageType: null,
    phone_number: "",
    customer_name: "",
    customer_company_name: "",
    servicePlanName: "",
    serviceContentNameList: [],
    serviceCampaignPulldownName: "",
    serviceCampaignCheckboxName: [],
    servicePaymentMethodName: "",
    serviseCustomerListID: "",
    pullDownServiceName: "",
    checkBoxServiceNames: "",
    smsMessagePatternID: null,
    customerInfo: {},
    changeAccount: 0,
    changeAccountID: null,
  });
  const [entryToEntryAddressOptionName, setEntryToEntryAddressOptionName] =
    useState("");
  // コピーエントリーウィンドウのサービス一覧
  const [
    entryToEntrySelectServisePlanList,
    setEntryToEntrySelectServisePlanList,
  ] = useState<{ service_name: string }[]>([]);
  const [
    entryToEntrySelectServiseContentList,
    setEntryToEntrySelectServiseContentList,
  ] = useState<{ service_name: string }[]>([]);
  const [
    entryToEntrySelectServiseCampaignPulldownList,
    setEntryToEntrySelectServiseCampaignPulldownList,
  ] = useState<{ service_name: string }[]>([]);
  const [
    entryToEntrySelectServiseCampaignCheckboxList,
    setEntryToEntrySelectServiseCampaignCheckboxList,
  ] = useState<{ service_name: string }[]>([]);
  const [
    entryToEntrySelectServisePaymentList,
    setEntryToEntrySelectServisePaymentList,
  ] = useState<{ payment_method: string }[]>([]);
  const [entryToEntryUniqueOptinList, setEntryToEntryUniqueOptinList] =
    useState<{ [key: string]: string | number | string[] }[]>([]);
  const [entryToEntryPostPictures, setEntryToEntryPostPictures] = useState<{
    [key: string]: File;
  }>({});
  const [onPostButton, setOnPostButton] = useState(false);
  const [selectedProductId, setSelectedProductId] = useState<number | null>(
    null,
  );
  const [selectedProductName, setSelectedProductName] = useState<string>("");
  const openEntryToEntryData = async (
    contractId: string,
    changeAccount: number,
    changeAccountID: number | null,
  ) => {
    try {
      setEntryToEntryDataInf((prev) => ({
        ...prev,
        addStatus: "loading",
      }));
      const result = await getContractCopyEntryBefore(
        contractId,
        changeAccount,
        changeAccountID,
      );
      setEntryToEntryDataInf((prev) => ({
        ...prev,
        addStatus: "product",
        contractId,
        changeAccount,
        changeAccountID,
        contractData: result.contract_data,
        entryProductList: result.entryProductList,
        beforeOptionData: result.beforeOptionData,
      }));
    } catch (e) {
      console.error(e);
      setEntryToEntryDataInf((prev) => ({
        ...prev,
        addStatus: "",
      }));
    }
  };
  async function postEntryToEntryData(addData: any) {
    if (entryToEntryDataInf.outSiteEntry === 1) {
      // 外部ET: postContractShortMessage呼び出し
      const { postResponce } = await postContractShortMessage(
        {
          ...addData,
          productName: selectedProductName,
          pullDownServiceName: addData.servicePlanName,
          checkBoxServiceNames: Array.isArray(addData.serviceContentNameList)
            ? addData.serviceContentNameList.join(",")
            : "",
          outsideMessageType: entryToEntryDataInf.outsideMessageType,
          smsMessagePatternID: entryToEntryDataInf.smsMessagePatternID,
          site_path: entryToEntryDataInf.site_path,
        } as any,
        "",
        "",
        "",
      );
      if (postResponce === "success") {
        closeEntryToEntryModal();
        setOnDataAddModalResult("success");
      } else {
        setOnDataAddModalResult(postResponce);
      }
    } else {
      // 内部ET: 既存postContract呼び出し
      const postResponce = await postContract(addData);
      if (postResponce === "success") {
        closeEntryToEntryModal();
        getProductNameListFromHistory();
        setOnDataAddModalResult("success");
      } else {
        setOnDataAddModalResult(postResponce);
      }
    }
  }
  const closeEntryToEntryModal = () => {
    setEntryToEntryDataInf({
      addStatus: "",
      contractId: "",
      changeAccount: 0,
      changeAccountID: null,
      productId: null,
      contractData: [],
      entryProductList: [],
      beforeOptionData: [],
      optionData: [],
      outSiteEntry: 0,
      site_path: "",
      outsideMessageType: null,
      smsMessagePatternID: null,
    });
    setCustomerInfo({});
    setEntryToEntryAddressOptionName("");
    setEntryToEntryPostPictures({});
    setOnPostButton(false);
    setSelectedProductId(null);
    setSelectedProductName("");
  };

  // 検索項目
  const [serchColumn, setSerchColumn] = useState<{ [key: string]: string }>({});
  const [serchString, setSerchString] = useState<{ [key: string]: string }>({});
  const [serchStringView, setSerchStringView] = useState<{
    [key: string]: string;
  }>({});

  // ソート項目
  const [sortColumn, setSortColumn] = useState<
    {
      key: string;
      sort: string;
    }[]
  >([]);

  // 項目データ読み込み中フラグ
  const [columnLoading, setColumnLoading] = useState(true);

  useEffect(() => {
    if (contractScreenColumn.length > 0) {
      // 検索項目
      const serchColumn = contractScreenColumn.reduce((column, difine) => {
        if (difine.serch === true) {
          if (difine.serchType === "date") {
            return {
              ...column,
              [difine.key + "_start"]: "",
              [difine.key + "_end"]: "",
            };
          } else {
            return {
              ...column,
              [difine.key]: "",
            };
          }
        } else {
          return {
            ...column,
          };
        }
      }, {});
      setSerchColumn(serchColumn);
      setSerchString(serchColumn);
      setSerchStringView(serchColumn);

      // ソート項目
      const sortColumn = contractScreenColumn
        .filter((column) => {
          return column.sort;
        })
        .map((column) => {
          return {
            key: column.key,
            sort: "DESC",
          };
        })
        .sort((a, b) => {
          if (a.key === "post_date") return -1;
          if (b.key === "post_date") return 1;
          return 0;
        });
      setSortColumn(sortColumn);
      setColumnLoading(false);
    }
  }, [contractScreenColumn]);

  // 顧客一覧取得
  async function getTableData(edit: boolean) {
    if (!edit) {
      setIsLoading(true);
    }
    const fetchData = await getContracts(
      {
        ...serchString,
        displayNumber,
        pageNumber,
      },
      sortColumn,
      contractScreenColumn,
    );
    if (fetchData === null) {
      setFetchData([]);
      setTotalCount(0);
      setMaxPageNumber(1);
      setPageNumber(1);
    } else if (fetchData) {
      setFetchData(fetchData.contracts);
      const countContracts = Number(fetchData.countContracts);
      setTotalCount(countContracts);
      setMaxPageNumber(Math.ceil(countContracts / displayNumber));
    }
    if (!edit) {
      setIsLoading(false);
    }
    setFirstLoading(false);
  }
  // 初回データ取得
  useEffect(() => {
    if (firstLoading) {
      getTableData(false);
    }
  }, []);

  // テーブルデータの更新受付
  const [changeTableData, setChangeTableData] = useState(false);

  // 変更があったときのみ
  useEffect(() => {
    if (!firstLoading && changeTableData) {
      getTableData(false);
    } else if (columnLoading === false) {
      setChangeTableData(true);
    }
  }, [serchString, displayNumber, pageNumber, sortColumn]);

  // 顧客詳細取得
  async function getDataDetail(key: { [key: string]: string }, edit: boolean) {
    if (!edit) {
      setIsLoading(true);
    }
    const id = key.id;
    const service_id = key.service_id;
    const { detail_data, option_data, contract_history } = await getContract(
      id,
      service_id,
    );
    if (detail_data) {
      setDataDetail(detail_data);
      setDataDetailOption(option_data);
      setDataDetailHistory(contract_history);
      setSelectHistory(detail_data.contract_version as number);
    } else {
      setDataDetail(null);
      setDataDetailOption([]);
      setDataDetailHistory([]);
      setSelectHistory(0);
    }
    if (!edit) {
      setIsLoading(false);
    }
  }

  // 詳細（履歴）取得
  async function getOldDataDetail(
    id: string,
    service_plan_id: string,
    contract_version: number,
  ) {
    setIsLoading(true);
    setDataDetail(null);
    const last_contract_version = dataDetailHistory.reduce(
      (max, item) =>
        item.contract_version > max ? item.contract_version : max,
      dataDetailHistory[0].contract_version,
    );
    if (contract_version === last_contract_version) {
      await getDataDetail({ id, service_id: service_plan_id }, true);
      setIsLoading(false);
      return;
    } else {
      const { detail_data } = await getOldContract(
        id,
        service_plan_id,
        contract_version,
      );
      setDataDetail(detail_data);
      setSelectHistory(contract_version);
      setIsLoading(false);
    }
  }

  // 顧客編集
  async function putEditData() {
    if (editData !== null) {
      setIsLoading(true);
      const id = editData.tableId as string;
      const service_id = editData.service_id as string;
      setEditData({
        ...editData,
        status: "editing",
      });
      if (editData.editType === "customer_picture") {
        if (
          editData.customer_picture &&
          typeof editData.editValue !== "string"
        ) {
          // 顧客情報の画像変更
          const editValue = editData.editValue as {
            [key: string]: string | string[];
          };
          let customer_info = { ...editValue };

          const fileName = editData.customer_picture.name;
          const date = new Date();
          const year = date.getFullYear();
          const month = String(date.getMonth() + 1).padStart(2, "0"); // 月は0始まりのため+1
          const day = String(date.getDate()).padStart(2, "0");
          const hours = String(date.getHours()).padStart(2, "0");
          const minutes = String(date.getMinutes()).padStart(2, "0");
          const seconds = String(date.getSeconds()).padStart(2, "0");
          const nowTimeName = `${year}${month}${day}${hours}${minutes}${seconds}`;
          const { presigned_object, destination_key } =
            await getPresignedPostPicture(nowTimeName, fileName);
          // POSTする form に持たせるデータを生成する
          const formData = new FormData();
          for (const key in presigned_object.fields) {
            formData.append(key, presigned_object.fields[key]);
          }
          formData.append("file", editData.customer_picture);
          // ファイルをS3にアップロード
          await postPresignedPost(presigned_object.url, formData);
          customer_info[editData.key] = destination_key;
          const _EditData = {
            ...editData,
            editValue: customer_info,
          };
          const putResponce = await putContract(_EditData);
          await getDataDetail({ id, service_id }, true);
          await getTableData(true);
          await getSubtableDataContractCustomerInfo();
          setEditData({
            ..._EditData,
            status: putResponce,
          });
        }
      } else {
        const putResponce = await putContract(editData);
        await getDataDetail({ id, service_id }, true);
        await getTableData(true);
        await getSubtableDataContractCustomerInfo();
        setEditData({
          ...editData,
          status: putResponce,
        });
      }
      setIsLoading(false);
    }
  }

  // データ無効化
  const [deleteDataInf, setDeleteDataInf] = useState<{
    status: null | "loading" | "open" | "success" | "failed";
    key: { [key: string]: string };
    message: string;
  }>({
    status: null,
    key: {},
    message: "",
  });
  async function deleteData() {
    setDeleteDataInf({
      ...deleteDataInf,
      status: "loading",
    });
    const id = deleteDataInf.key.id;
    const responce = await deleteContract(id);
    if (responce == "success") {
      await getTableData(false);
      setDeleteDataInf({
        ...deleteDataInf,
        status: "success",
      });
    } else {
      setDeleteDataInf({
        ...deleteDataInf,
        status: "failed",
        message: responce,
      });
    }
  }
  useEffect(() => {
    if (deleteDataInf.status === "loading") {
      setIsLoading(true);
    } else if (deleteDataInf.status !== null) {
      setIsLoading(false);
    }
  }, [deleteDataInf]);

  // 解約
  const [cancelDataInf, setCancelDataInf] = useState<{
    status: null | "loading" | "open" | "success" | "failed";
    key: { [key: string]: string };
    message: string;
    cancellAction: string;
    cancellSmsList: {
      id: number;
      cancell_sms_name: string;
      cancell_sms_type: number;
      cancell_sms_sender: string;
      cancell_sms_body: string;
      cancell_sms_title: string;
      source: "product" | "outside_entry_form";
    }[];
    selectedCancellSms: {
      id: number;
      source: "product" | "outside_entry_form";
    } | null;
    destinationPhoneNumber: string;
    destinationMailAddress: string;
  }>({
    status: null,
    key: {},
    message: "",
    cancellAction: "",
    cancellSmsList: [],
    selectedCancellSms: null,
    destinationPhoneNumber: "",
    destinationMailAddress: "",
  });
  async function cancelData() {
    setCancelDataInf((prev) => ({ ...prev, status: "loading" }));
    const id = cancelDataInf.key.id;
    const responce = await cancellContract(
      id,
      cancelDataInf.selectedCancellSms,
    );
    if (responce == "success") {
      await getTableData(false);
      setCancelDataInf((prev) => ({ ...prev, status: "success" }));
    } else {
      setCancelDataInf((prev) => ({
        ...prev,
        status: "failed",
        message: responce ?? "解約に失敗しました。",
      }));
    }
  }
  useEffect(() => {
    if (cancelDataInf.status === "loading") {
      setIsLoading(true);
    } else if (cancelDataInf.status !== null) {
      setIsLoading(false);
    }
  }, [cancelDataInf]);

  // 個人情報削除
  const [deletePersonDataInf, setDeletePersonDataInf] = useState<{
    status: null | "loading" | "open" | "success" | "failed";
    key: { [key: string]: string };
    message: string;
  }>({
    status: null,
    key: {},
    message: "",
  });
  async function deletePersonData() {
    setDeletePersonDataInf({
      ...deletePersonDataInf,
      status: "loading",
    });
    const id = deletePersonDataInf.key.id;
    const responce = await deletePersonContract(id);
    if (responce == "success") {
      await getTableData(false);
      if (getSubTableName.name === "顧客情報一覧") {
        setGetSubTableName({
          name: "",
          key: {},
          subData: [],
        });
      }
      setDeletePersonDataInf({
        ...deletePersonDataInf,
        status: "success",
      });
    } else {
      setDeletePersonDataInf({
        ...deletePersonDataInf,
        status: "failed",
        message: responce,
      });
    }
  }
  useEffect(() => {
    if (deletePersonDataInf.status === "loading") {
      setIsLoading(true);
    } else if (deletePersonDataInf.status !== null) {
      setIsLoading(false);
    }
  }, [deletePersonDataInf]);

  // データ登録ウィンドウのサービス一覧
  const [selectServisePlanList, setSelectServisePlanList] = useState<
    { service_name: string }[]
  >([]);
  const [selectServiseContentList, setSelectServiseContentList] = useState<
    { service_name: string }[]
  >([]);
  const [
    selectServiseCampaignPulldownList,
    setSelectServiseCampaignPulldownList,
  ] = useState<{ service_name: string }[]>([]);
  const [
    selectServiseCampaignCheckboxList,
    setSelectServiseCampaignCheckboxList,
  ] = useState<{ service_name: string }[]>([]);
  const [selectServisePaymentList, setSelectServisePaymentList] = useState<
    { payment_method: string }[]
  >([]);
  const [uniqueOptinList, setUniqueOptinList] = useState<
    { [key: string]: string | number | string[] }[]
  >([]);
  const [addressOptionName, setAddressOptionName] = useState("");

  // 画像データ保持用
  const [postPictures, setPostPicture] = useState<{
    [key: string]: File;
  }>({});

  function closeAddModal() {
    setAddData({
      addStatus: null,
      outSiteEntry: 0,
      outsideSiteUrl: "",
      outsideServiceUrl: "",
      viewOutsideServiceUrl: 0,
      productId: null,
      productName: "",
      have_entry_form: null,
      site_path_list: [],
      site_path: "",
      outsideMessageType: null,
      phone_number: "",
      customer_name: "",
      customer_company_name: "",
      servicePlanName: "",
      serviceContentNameList: [],
      serviceCampaignPulldownName: "",
      serviceCampaignCheckboxName: [],
      servicePaymentMethodName: "",
      serviseCustomerListID: "",
      pullDownServiceName: "",
      checkBoxServiceNames: "",
      smsMessagePatternID: null,
      customerInfo: {},
      changeAccount: 0,
      changeAccountID: null,
    });
    setSelectServisePlanList([]);
    setSelectServiseContentList([]);
    setSelectServiseCampaignPulldownList([]);
    setSelectServiseCampaignCheckboxList([]);
    setSelectServisePaymentList([]);
    setUniqueOptinList([]);
    setContractProductList([]);
    setAddressOptionName("");
    setPostPicture({});
  }

  // 契約情報更新CSV取込
  const [postCSVStatusHeader, setPostCSVStatusHeader] = useState<string[]>([]);
  const [postCSVStatus, setPostCSVStatus] = useState<{
    status:
      | "none"
      | "open"
      | "column"
      | "posting"
      | "result"
      | "loading"
      | "error";
    message: string;
    result: { [key: string]: any }[];
    header_location: string;
    destination_key: string;
    product_id: null | number;
    product_key: string;
    header_inf: {
      [key: string]: string;
    };
  }>({
    status: "none",
    message: "",
    result: [],
    header_location: "None",
    destination_key: "",
    product_id: null,
    product_key: "",
    header_inf: {},
  });
  useEffect(() => {
    if (postCSVStatus.status === "loading") {
      setIsLoading(true);
    } else if (postCSVStatus.status !== "none") {
      setIsLoading(false);
    }
  }, [postCSVStatus]);
  async function postContractStatusCSV(postDatas: File) {
    setPostCSVStatus({
      ...postCSVStatus,
      status: "loading",
      message: "CSV情報確認中",
    });
    // 著名付きURL(post用)を作成
    const fileName = postDatas.name;
    const date = new Date();
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0"); // 月は0始まりのため+1
    const day = String(date.getDate()).padStart(2, "0");
    const hours = String(date.getHours()).padStart(2, "0");
    const minutes = String(date.getMinutes()).padStart(2, "0");
    const seconds = String(date.getSeconds()).padStart(2, "0");
    const nowTimeName = `${year}${month}${day}${hours}${minutes}${seconds}`;
    const { presigned_object, destination_key } = await getPresignedPostCSV(
      nowTimeName,
      fileName,
    );
    // POSTする form に持たせるデータを生成する
    const formData = new FormData();
    for (const key in presigned_object.fields) {
      formData.append(key, presigned_object.fields[key]);
    }
    formData.append("file", postDatas);
    // ファイルをS3にアップロード
    await postPresignedPost(presigned_object.url, formData);
    const { headers, csv_column } = await getPostCSVHeader(
      destination_key,
      postCSVStatus.product_id,
    );
    const header_inf = headers.reduce((column, difine) => {
      if (csv_column[difine]) {
        return {
          ...column,
          [difine]: csv_column[difine],
        };
      } else {
        return {
          ...column,
          [difine]: "",
        };
      }
    }, {});
    setPostCSVStatusHeader(headers);
    setPostCSVStatus({
      ...postCSVStatus,
      status: "column",
      message: "CSV情報確認中",
      header_inf,
      destination_key,
    });
  }
  async function startPutContractStatusCSV() {
    setPostCSVStatus({
      ...postCSVStatus,
      status: "posting",
      message: "CSV情報確認中",
    });

    const path = "contractStatus";
    const idToken = loginUser?.idToken;
    const bodys = {
      type: "post_csv",
      path: path,
      destination_key: postCSVStatus.destination_key,
      product_id: postCSVStatus.product_id,
      product_key: postCSVStatus.product_key,
      header_inf: postCSVStatus.header_inf,
      idToken,
    };

    // WebSocketオブジェクトを生成しサーバとの接続を開始
    const url =
      CONST.inputCSVContractStatusWebSocketAPIURL + "?Authorization=" + idToken;
    const websocket = new WebSocket(url);
    // メッセージ受信時のイベントハンドラを設定
    const onMessage = async (event_websocket: any) => {
      const decodedData = JSON.parse(event_websocket.data);
      if (decodedData.message === "success") {
        setPostCSVStatus({
          ...postCSVStatus,
          status: "loading",
          message:
            decodedData.header_location !== "None"
              ? "CSV取込完了。エラー内容をダウンロードして確認してください。"
              : "CSV取込完了",
          result: postCSVStatus.result,
          header_location: decodedData.header_location,
        });
        await getTableData(false);
        setPostCSVStatus({
          ...postCSVStatus,
          status: "result",
          message:
            decodedData.header_location !== "None"
              ? "CSV取込完了。エラー内容をダウンロードして確認してください。"
              : "CSV取込完了",
          result: postCSVStatus.result,
          header_location: decodedData.header_location,
        });
        websocket.close();
      } else if (decodedData.message === "header_error") {
        setPostCSVStatus({
          ...postCSVStatus,
          status: "error",
          message:
            "「" + decodedData.header + "」がCSV項目に含まれていません。",
        });
        websocket.close();
      } else if (
        decodedData.message !== "End_WebSocket_API" &&
        decodedData.message !== "Endpoint request timed out"
      ) {
        let _result = postCSVStatus.result;
        if (decodedData.res_results) {
          _result.push(decodedData.res_results);
        }
        setPostCSVStatus({
          ...postCSVStatus,
          status: "posting",
          message: decodedData.message,
          result: _result,
        });
      }
    };
    websocket.onmessage = onMessage;
    websocket.onopen = () => websocket.send(JSON.stringify(bodys));
  }

  // 契約サービスCSV更新取込
  const [putCSVContractService, setPutCSVContractService] = useState<{
    status: "none" | "open" | "posting" | "result" | "loading" | "error";
    message: string;
    result: { [key: string]: any }[];
    header_location: string;
  }>({
    status: "none",
    message: "",
    result: [],
    header_location: "None",
  });
  useEffect(() => {
    if (putCSVContractService.status === "loading") {
      setIsLoading(true);
    } else if (putCSVContractService.status !== "none") {
      setIsLoading(false);
    }
  }, [putCSVContractService]);
  async function putContractServiceCSV(postDatas: File) {
    setPutCSVContractService({
      status: "loading",
      message: "CSV情報確認中",
      result: [],
      header_location: "None",
    });
    // 著名付きURL(post用)を作成
    const fileName = postDatas.name;
    const date = new Date();
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0"); // 月は0始まりのため+1
    const day = String(date.getDate()).padStart(2, "0");
    const hours = String(date.getHours()).padStart(2, "0");
    const minutes = String(date.getMinutes()).padStart(2, "0");
    const seconds = String(date.getSeconds()).padStart(2, "0");
    const nowTimeName = `${year}${month}${day}${hours}${minutes}${seconds}`;
    const { presigned_object, destination_key } = await getPresignedPostCSV(
      nowTimeName,
      fileName,
    );
    // POSTする form に持たせるデータを生成する
    const formData = new FormData();
    for (const key in presigned_object.fields) {
      formData.append(key, presigned_object.fields[key]);
    }
    formData.append("file", postDatas);
    // ファイルをS3にアップロード
    await postPresignedPost(presigned_object.url, formData);

    setPutCSVContractService({
      status: "posting",
      message: "CSV情報確認中",
      result: [],
      header_location: "None",
    });

    const path = "contractService";
    const idToken = loginUser?.idToken;
    const bodys = {
      type: "post_csv",
      path: path,
      destination_key: destination_key,
      idToken,
    };

    // WebSocketオブジェクトを生成しサーバとの接続を開始
    const url = CONST.inputCSVWebSocketAPIURL + "?Authorization=" + idToken;
    const websocket = new WebSocket(url);
    // メッセージ受信時のイベントハンドラを設定
    const onMessage = async (event_websocket: any) => {
      const decodedData = JSON.parse(event_websocket.data);
      if (decodedData.message === "success") {
        setPutCSVContractService({
          status: "loading",
          message: "CSV取込完了",
          result: putCSVContractService.result,
          header_location: decodedData.header_location,
        });
        await getTableData(false);
        if (getSubTableName.name === "コンテンツ一覧") {
          await getSubtableDataContractServiceContent();
        }
        setPutCSVContractService({
          status: "result",
          message: "CSV取込完了",
          result: putCSVContractService.result,
          header_location: decodedData.header_location,
        });
        websocket.close();
      } else if (decodedData.message === "header_error") {
        setPutCSVContractService({
          status: "error",
          message:
            "「" + decodedData.header + "」がCSV項目に含まれていません。",
          result: [],
          header_location: "None",
        });
        websocket.close();
      } else if (
        decodedData.message !== "End_WebSocket_API" &&
        decodedData.message !== "Endpoint request timed out"
      ) {
        let _result = putCSVContractService.result;
        if (decodedData.res_results) {
          _result.push(decodedData.res_results);
        }
        setPutCSVContractService({
          status: "posting",
          message: decodedData.message,
          result: _result,
          header_location: "None",
        });
      }
    };
    websocket.onmessage = onMessage;
    websocket.onopen = () => websocket.send(JSON.stringify(bodys));
  }

  // 営業アカウント更新CSV取込
  const [postCSVSaleAccount, setPostCSVSaleAccount] = useState<{
    status: "none" | "open" | "posting" | "result" | "loading" | "error";
    message: string;
    result: { [key: string]: any }[];
    header_location: string;
  }>({
    status: "none",
    message: "",
    result: [],
    header_location: "None",
  });
  useEffect(() => {
    if (postCSVSaleAccount.status === "loading") {
      setIsLoading(true);
    } else if (postCSVSaleAccount.status !== "none") {
      setIsLoading(false);
    }
  }, [postCSVSaleAccount]);
  async function postContractSaleAccountCSV(postDatas: File) {
    setPostCSVSaleAccount({
      status: "loading",
      message: "CSV情報確認中",
      result: [],
      header_location: "None",
    });
    // 著名付きURL(post用)を作成
    const fileName = postDatas.name;
    const date = new Date();
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0"); // 月は0始まりのため+1
    const day = String(date.getDate()).padStart(2, "0");
    const hours = String(date.getHours()).padStart(2, "0");
    const minutes = String(date.getMinutes()).padStart(2, "0");
    const seconds = String(date.getSeconds()).padStart(2, "0");
    const nowTimeName = `${year}${month}${day}${hours}${minutes}${seconds}`;
    const { presigned_object, destination_key } = await getPresignedPostCSV(
      nowTimeName,
      fileName,
    );
    // POSTする form に持たせるデータを生成する
    const formData = new FormData();
    for (const key in presigned_object.fields) {
      formData.append(key, presigned_object.fields[key]);
    }
    formData.append("file", postDatas);
    // ファイルをS3にアップロード
    await postPresignedPost(presigned_object.url, formData);

    setPostCSVSaleAccount({
      status: "posting",
      message: "CSV情報確認中",
      result: [],
      header_location: "None",
    });

    const path = "contractSaleAccount";
    const idToken = loginUser?.idToken;
    const bodys = {
      type: "post_csv",
      path: path,
      destination_key: destination_key,
      idToken,
    };

    // WebSocketオブジェクトを生成しサーバとの接続を開始
    const url = CONST.inputCSVWebSocketAPIURL + "?Authorization=" + idToken;
    const websocket = new WebSocket(url);
    // メッセージ受信時のイベントハンドラを設定
    const onMessage = async (event_websocket: any) => {
      const decodedData = JSON.parse(event_websocket.data);
      if (decodedData.message === "success") {
        setPostCSVSaleAccount({
          status: "loading",
          message: "CSV取込完了",
          result: postCSVSaleAccount.result,
          header_location: decodedData.header_location,
        });
        await getTableData(false);
        setPostCSVSaleAccount({
          status: "result",
          message: "CSV取込完了",
          result: postCSVSaleAccount.result,
          header_location: decodedData.header_location,
        });
        websocket.close();
      } else if (decodedData.message === "header_error") {
        setPostCSVSaleAccount({
          status: "error",
          message:
            "「" + decodedData.header + "」がCSV項目に含まれていません。",
          result: [],
          header_location: "None",
        });
        websocket.close();
      } else if (
        decodedData.message !== "End_WebSocket_API" &&
        decodedData.message !== "Endpoint request timed out"
      ) {
        let _result = postCSVSaleAccount.result;
        if (decodedData.res_results) {
          _result.push(decodedData.res_results);
        }
        setPostCSVSaleAccount({
          status: "posting",
          message: decodedData.message,
          result: _result,
          header_location: "None",
        });
      }
    };
    websocket.onmessage = onMessage;
    websocket.onopen = () => websocket.send(JSON.stringify(bodys));
  }

  // 申込番号更新CSV取込
  const [postCSVContractNumber, setPostCSVContractNumber] = useState<{
    status: "none" | "open" | "posting" | "result" | "loading" | "error";
    message: string;
    result: { [key: string]: any }[];
    header_location: string;
  }>({
    status: "none",
    message: "",
    result: [],
    header_location: "None",
  });
  useEffect(() => {
    if (postCSVContractNumber.status === "loading") {
      setIsLoading(true);
    } else if (postCSVContractNumber.status !== "none") {
      setIsLoading(false);
    }
  }, [postCSVContractNumber]);
  async function postContractNumberCSV(postDatas: File) {
    setPostCSVContractNumber({
      status: "loading",
      message: "CSV情報確認中",
      result: [],
      header_location: "None",
    });
    // 著名付きURL(post用)を作成
    const fileName = postDatas.name;
    const date = new Date();
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0"); // 月は0始まりのため+1
    const day = String(date.getDate()).padStart(2, "0");
    const hours = String(date.getHours()).padStart(2, "0");
    const minutes = String(date.getMinutes()).padStart(2, "0");
    const seconds = String(date.getSeconds()).padStart(2, "0");
    const nowTimeName = `${year}${month}${day}${hours}${minutes}${seconds}`;
    const { presigned_object, destination_key } = await getPresignedPostCSV(
      nowTimeName,
      fileName,
    );
    // POSTする form に持たせるデータを生成する
    const formData = new FormData();
    for (const key in presigned_object.fields) {
      formData.append(key, presigned_object.fields[key]);
    }
    formData.append("file", postDatas);
    // ファイルをS3にアップロード
    await postPresignedPost(presigned_object.url, formData);

    setPostCSVContractNumber({
      status: "posting",
      message: "CSV情報確認中",
      result: [],
      header_location: "None",
    });

    const path = "contractNumber";
    const idToken = loginUser?.idToken;
    const bodys = {
      type: "post_csv",
      path: path,
      destination_key: destination_key,
      idToken,
    };

    // WebSocketオブジェクトを生成しサーバとの接続を開始
    const url = CONST.inputCSVWebSocketAPIURL + "?Authorization=" + idToken;
    const websocket = new WebSocket(url);
    // メッセージ受信時のイベントハンドラを設定
    const onMessage = async (event_websocket: any) => {
      const decodedData = JSON.parse(event_websocket.data);
      if (decodedData.message === "success") {
        setPostCSVContractNumber({
          status: "loading",
          message: "CSV取込完了",
          result: postCSVContractNumber.result,
          header_location: decodedData.header_location,
        });
        await getTableData(false);
        setPostCSVContractNumber({
          status: "result",
          message: "CSV取込完了",
          result: postCSVContractNumber.result,
          header_location: decodedData.header_location,
        });
        websocket.close();
      } else if (decodedData.message === "header_error") {
        setPostCSVContractNumber({
          status: "error",
          message:
            "「" + decodedData.header + "」がCSV項目に含まれていません。",
          result: [],
          header_location: "None",
        });
        websocket.close();
      } else if (
        decodedData.message !== "End_WebSocket_API" &&
        decodedData.message !== "Endpoint request timed out"
      ) {
        let _result = postCSVContractNumber.result;
        if (decodedData.res_results) {
          _result.push(decodedData.res_results);
        }
        setPostCSVContractNumber({
          status: "posting",
          message: decodedData.message,
          result: _result,
          header_location: "None",
        });
      }
    };
    websocket.onmessage = onMessage;
    websocket.onopen = () => websocket.send(JSON.stringify(bodys));
  }

  // 契約事前一括取込
  const [postContractCSVStatus, setPostContractCSVStatus] = useState<{
    status: "none" | "open" | "posting" | "result" | "loading" | "error";
    message: string;
    result: { [key: string]: any }[];
    header_location: string;
  }>({
    status: "none",
    message: "",
    result: [],
    header_location: "None",
  });
  useEffect(() => {
    if (postContractCSVStatus.status === "loading") {
      setIsLoading(true);
    } else if (postContractCSVStatus.status !== "none") {
      setIsLoading(false);
    }
  }, [postContractCSVStatus]);
  async function postContractCSV(postDatas: File) {
    setPostContractCSVStatus({
      status: "loading",
      message: "CSV情報確認中",
      result: [],
      header_location: "None",
    });
    // 著名付きURL(post用)を作成
    const fileName = postDatas.name;
    const date = new Date();
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0"); // 月は0始まりのため+1
    const day = String(date.getDate()).padStart(2, "0");
    const hours = String(date.getHours()).padStart(2, "0");
    const minutes = String(date.getMinutes()).padStart(2, "0");
    const seconds = String(date.getSeconds()).padStart(2, "0");
    const nowTimeName = `${year}${month}${day}${hours}${minutes}${seconds}`;
    const { presigned_object, destination_key } = await getPresignedPostCSV(
      nowTimeName,
      fileName,
    );
    // POSTする form に持たせるデータを生成する
    const formData = new FormData();
    for (const key in presigned_object.fields) {
      formData.append(key, presigned_object.fields[key]);
    }
    formData.append("file", postDatas);
    // ファイルをS3にアップロード
    await postPresignedPost(presigned_object.url, formData);

    setPostContractCSVStatus({
      status: "posting",
      message: "CSV情報確認中",
      result: [],
      header_location: "None",
    });

    const path = "addContract";
    const idToken = loginUser?.idToken;
    const bodys = {
      type: "post_csv",
      path: path,
      destination_key: destination_key,
      idToken,
    };

    // WebSocketオブジェクトを生成しサーバとの接続を開始
    const url = CONST.inputCSVWebSocketAPIURL + "?Authorization=" + idToken;
    const websocket = new WebSocket(url);
    // メッセージ受信時のイベントハンドラを設定
    const onMessage = async (event_websocket: any) => {
      const decodedData = JSON.parse(event_websocket.data);
      if (decodedData.message === "success") {
        setPostContractCSVStatus({
          status: "loading",
          message: "CSV取込完了",
          result: postContractCSVStatus.result,
          header_location: decodedData.header_location,
        });
        await getProductList();
        await getTableData(false);
        setPostContractCSVStatus({
          status: "result",
          message: "CSV取込完了",
          result: postContractCSVStatus.result,
          header_location: decodedData.header_location,
        });
        websocket.close();
      } else if (decodedData.message === "header_error") {
        setPostContractCSVStatus({
          status: "error",
          message:
            "「" + decodedData.header + "」がCSV項目に含まれていません。",
          result: [],
          header_location: "None",
        });
        websocket.close();
      } else if (
        decodedData.message !== "End_WebSocket_API" &&
        decodedData.message !== "Endpoint request timed out"
      ) {
        let _result = postContractCSVStatus.result;
        if (decodedData.res_results) {
          _result.push(decodedData.res_results);
        }
        setPostContractCSVStatus({
          status: "posting",
          message: decodedData.message,
          result: _result,
          header_location: "None",
        });
      }
    };
    websocket.onmessage = onMessage;
    websocket.onopen = () => websocket.send(JSON.stringify(bodys));
  }

  //契約一括エントリー
  const [postEntryContractCSVStatus, setPostEntryContractCSVStatus] = useState<{
    status: "none" | "open" | "posting" | "result" | "loading" | "error";
    message: string;
    result: { [key: string]: any }[];
    header_location: string;
  }>({
    status: "none",
    message: "",
    result: [],
    header_location: "None",
  });
  useEffect(() => {
    if (postEntryContractCSVStatus.status === "loading") {
      setIsLoading(true);
    } else if (postEntryContractCSVStatus.status !== "none") {
      setIsLoading(false);
    }
  }, [postEntryContractCSVStatus]);
  async function postEntryContractCSV(postDatas: File) {
    setPostEntryContractCSVStatus({
      status: "loading",
      message: "CSV情報確認中",
      result: [],
      header_location: "None",
    });
    // 著名付きURL(post用)を作成
    const fileName = postDatas.name;
    const date = new Date();
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0"); // 月は0始まりのため+1
    const day = String(date.getDate()).padStart(2, "0");
    const hours = String(date.getHours()).padStart(2, "0");
    const minutes = String(date.getMinutes()).padStart(2, "0");
    const seconds = String(date.getSeconds()).padStart(2, "0");
    const nowTimeName = `${year}${month}${day}${hours}${minutes}${seconds}`;
    const { presigned_object, destination_key } = await getPresignedPostCSV(
      nowTimeName,
      fileName,
    );
    // POSTする form に持たせるデータを生成する
    const formData = new FormData();
    for (const key in presigned_object.fields) {
      formData.append(key, presigned_object.fields[key]);
    }
    formData.append("file", postDatas);
    // ファイルをS3にアップロード
    await postPresignedPost(presigned_object.url, formData);

    setPostEntryContractCSVStatus({
      status: "posting",
      message: "CSV情報確認中",
      result: [],
      header_location: "None",
    });

    const path = "entryContract";
    const idToken = loginUser?.idToken;
    const bodys = {
      type: "post_csv",
      path: path,
      destination_key: destination_key,
      idToken,
    };

    // WebSocketオブジェクトを生成しサーバとの接続を開始
    const url = CONST.inputCSVWebSocketAPIURL + "?Authorization=" + idToken;
    const websocket = new WebSocket(url);
    // メッセージ受信時のイベントハンドラを設定
    const onMessage = async (event_websocket: any) => {
      const decodedData = JSON.parse(event_websocket.data);
      if (decodedData.message === "success") {
        setPostEntryContractCSVStatus({
          status: "loading",
          message: "CSV取込完了",
          result: postEntryContractCSVStatus.result,
          header_location: decodedData.header_location,
        });
        await getTableData(false);
        setPostEntryContractCSVStatus({
          status: "result",
          message: "CSV取込完了",
          result: postEntryContractCSVStatus.result,
          header_location: decodedData.header_location,
        });
        websocket.close();
      } else if (decodedData.message === "header_error") {
        setPostEntryContractCSVStatus({
          status: "error",
          message:
            "「" + decodedData.header + "」がCSV項目に含まれていません。",
          result: [],
          header_location: "None",
        });
        websocket.close();
      } else if (
        decodedData.message !== "End_WebSocket_API" &&
        decodedData.message !== "Endpoint request timed out"
      ) {
        let _result = postEntryContractCSVStatus.result;
        if (decodedData.res_results) {
          _result.push(decodedData.res_results);
        }
        setPostEntryContractCSVStatus({
          status: "posting",
          message: decodedData.message,
          result: _result,
          header_location: "None",
        });
      }
    };
    websocket.onmessage = onMessage;
    websocket.onopen = () => websocket.send(JSON.stringify(bodys));
  }

  // 明細Excel取得
  const [getXLSXStatus, setGetXLSXStatus] = useState<{
    status: "none" | "open" | "getting" | "result" | "loading" | "error";
    message: string;
    contract_state: string;
    sale_company_id: number | null;
    sale_company_name: string;
    all_company: boolean;
    product_ids: number[];
    product_names: string[];
    all_product: boolean;
    merge_sheet: boolean;
    post_start_year: string;
    post_start_month: string;
    post_end_year: string;
    post_end_month: string;
    post_all_year: boolean;
    apply_start_year: string;
    apply_start_month: string;
    apply_end_year: string;
    apply_end_month: string;
    apply_all_year: boolean;
    opening_start_year: string;
    opening_start_month: string;
    opening_end_year: string;
    opening_end_month: string;
    opening_all_year: boolean;
    cancell_start_year: string;
    cancell_start_month: string;
    cancell_end_year: string;
    cancell_end_month: string;
    cancell_all_year: boolean;
  }>({
    status: "none",
    message: "",
    contract_state: "",
    sale_company_id: null,
    sale_company_name: "",
    all_company: false,
    product_ids: [],
    product_names: [],
    all_product: false,
    merge_sheet: false,
    post_start_year: lastYear.toString(),
    post_start_month: lastMonth.toString(),
    post_end_year: thisYear.toString(),
    post_end_month: thisMonth.toString(),
    post_all_year: false,
    apply_start_year: lastYear.toString(),
    apply_start_month: lastMonth.toString(),
    apply_end_year: thisYear.toString(),
    apply_end_month: thisMonth.toString(),
    apply_all_year: true,
    opening_start_year: lastYear.toString(),
    opening_start_month: lastMonth.toString(),
    opening_end_year: thisYear.toString(),
    opening_end_month: thisMonth.toString(),
    opening_all_year: true,
    cancell_start_year: lastYear.toString(),
    cancell_start_month: lastMonth.toString(),
    cancell_end_year: thisYear.toString(),
    cancell_end_month: thisMonth.toString(),
    cancell_all_year: true,
  });

  async function getPaymentsXLSX() {
    const idToken = loginUser?.idToken;
    const produntName = getXLSXStatus.all_product
      ? "全商材"
      : getXLSXStatus.product_names.join(",");

    const companyName = getXLSXStatus.all_company
      ? "全社"
      : getXLSXStatus.sale_company_name;
    const date = new Date();
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0"); // 月は0始まりのため+1
    const day = String(date.getDate()).padStart(2, "0");
    const hours = String(date.getHours()).padStart(2, "0");
    const minutes = String(date.getMinutes()).padStart(2, "0");
    const seconds = String(date.getSeconds()).padStart(2, "0");
    const nowTimeName = `${year}${month}${day}${hours}${minutes}${seconds}`;
    const fileName =
      loginUser?.authority !== "パートナー" &&
      loginUser?.authority !== "営業アカウント"
        ? "【契約一覧】商材:" +
          produntName +
          "_パートナー企業:" +
          companyName +
          "_" +
          nowTimeName +
          ".xlsx"
        : "【契約一覧】商材:" + produntName + "_" + nowTimeName + ".xlsx";
    const bodys = {
      type: "get_xlsx_contract",
      sale_company_id: getXLSXStatus.sale_company_id,
      sale_company_name: getXLSXStatus.sale_company_name,
      contract_state: getXLSXStatus.contract_state,
      all_company: getXLSXStatus.all_company,
      product_ids: getXLSXStatus.product_ids,
      product_names: getXLSXStatus.product_names,
      all_product: getXLSXStatus.all_product,
      merge_sheet: getXLSXStatus.merge_sheet,
      post_start_year: getXLSXStatus.post_start_year,
      post_start_month: getXLSXStatus.post_start_month,
      post_end_year: getXLSXStatus.post_end_year,
      post_end_month: getXLSXStatus.post_end_month,
      post_all_year: getXLSXStatus.post_all_year,
      apply_start_year: getXLSXStatus.apply_start_year,
      apply_start_month: getXLSXStatus.apply_start_month,
      apply_end_year: getXLSXStatus.apply_end_year,
      apply_end_month: getXLSXStatus.apply_end_month,
      apply_all_year: getXLSXStatus.apply_all_year,
      opening_start_year: getXLSXStatus.opening_start_year,
      opening_start_month: getXLSXStatus.opening_start_month,
      opening_end_year: getXLSXStatus.opening_end_year,
      opening_end_month: getXLSXStatus.opening_end_month,
      opening_all_year: getXLSXStatus.opening_all_year,
      cancell_start_year: getXLSXStatus.cancell_start_year,
      cancell_start_month: getXLSXStatus.cancell_start_month,
      cancell_end_year: getXLSXStatus.cancell_end_year,
      cancell_end_month: getXLSXStatus.cancell_end_month,
      cancell_all_year: getXLSXStatus.cancell_all_year,
      idToken,
      fileName,
    };
    // WebSocketオブジェクトを生成しサーバとの接続を開始
    const url =
      CONST.outputXLSXContractsWebSocketAPIURL + "?Authorization=" + idToken;
    const websocket = new WebSocket(url);
    // メッセージ受信時のイベントハンドラを設定
    const onMessage = async (event_websocket: any) => {
      const decodedData = JSON.parse(event_websocket.data);
      if (decodedData.message === "success") {
        const url = decodedData.url;
        const link = document.createElement("a");
        link.href = decodedData.url;
        link.setAttribute("download", fileName);
        document.body.appendChild(link);
        link.click();
        URL.revokeObjectURL(url);
        link.parentNode?.removeChild(link);

        setGetXLSXStatus({
          ...getXLSXStatus,
          status: "result",
          message: "エントリー一覧出力完了",
        });
        websocket.close();
      } else if (
        decodedData.message !== "End_WebSocket_API" &&
        decodedData.message !== "Endpoint request timed out"
      ) {
        setGetXLSXStatus({
          ...getXLSXStatus,
          status: "getting",
          message: decodedData.message,
        });
      }
    };
    websocket.onmessage = onMessage;
    websocket.onopen = () => websocket.send(JSON.stringify(bodys));
  }

  // 契約新規登録
  async function postAddData(customerInfo: {
    [key: string]: string | string[];
  }) {
    if (addData.outSiteEntry == 0) {
      const postResponce = await postContract({ ...addData, customerInfo });
      if (postResponce === "success") {
        await getTableData(true);
        getProductNameListFromHistory();
        closeAddModal();
        setOnDataAddModalResult("success");
      } else {
        setOnDataAddModalResult(postResponce);
        setAddData({
          ...addData,
          addStatus: "contract",
        });
      }
    } else if (addData.outSiteEntry == 1) {
      let mail_address = "@";
      uniqueOptinList.map((uniqueOptin) => {
        if (uniqueOptin.mail_address_flg === 1) {
          mail_address = addData.customerInfo[
            uniqueOptin.option_name as string
          ] as string;
        }
      });
      if (mail_address === "@" && addData.customerInfo["メールアドレス"]) {
        mail_address = addData.customerInfo["メールアドレス"] as string;
      }

      const {
        postResponce,
        outsideSiteUrl,
        outsideServiceUrl,
        viewOutsideServiceUrl,
      } = await postContractShortMessage(
        {
          ...addData,
          customerInfo,
        },
        mail_address,
        "",
        "",
      );
      if (postResponce === "success") {
        setAddData({
          ...addData,
          addStatus: "sms_success",
          outsideSiteUrl,
          outsideServiceUrl,
          viewOutsideServiceUrl,
        });
      } else {
        setOnDataAddModalResult(postResponce);
        setAddData({
          ...addData,
          addStatus: "contract",
        });
      }
    }
  }

  // コンテンツ一覧取得
  async function getSubtableDataContractServiceContent() {
    if (getSubTableName.key.id) {
      setIsLoading(true);
      const fetchData = await getContractServiceContents(
        getSubTableName.key.id,
      );
      setGetSubTableName({
        ...getSubTableName,
        subData: fetchData.sudDatas,
      });
      setIsLoading(false);
    }
  }

  // 顧客情報一覧取得
  async function getSubtableDataContractCustomerInfo() {
    if (getSubTableName.key.id) {
      setIsLoading(true);
      const { sudDatas, option_data } = await getContractCustomerInfos(
        getSubTableName.key.id,
      );
      const fetchData = option_data.map((option) => {
        return {
          ...option,
          id: sudDatas[0]["contract_id"],
          product_id: sudDatas[0]["product_id"],
          customer_info: sudDatas[0]["customer_info"],
          customer_info_key: option.option_name,
          customer_info_value: sudDatas[0]["customer_info"][option.option_name],
        };
      });
      setGetSubTableName({
        ...getSubTableName,
        subData: fetchData,
      });
      setIsLoading(false);
    }
  }

  // 顧客情報ダイレクト編集
  const [editDataContractCustomerInfo, setEditDataContractCustomerInfo] =
    useState<EditDataDifine | null>(null);
  async function putEditSubtableDataDirectContractCustomerInfo() {
    if (editDataContractCustomerInfo !== null) {
      setIsLoading(true);
      setEditDataContractCustomerInfo({
        ...editDataContractCustomerInfo,
        status: "editing",
      });

      if (editDataContractCustomerInfo.editType === "customer_picture") {
        if (
          editDataContractCustomerInfo.customer_picture &&
          typeof editDataContractCustomerInfo.editValue !== "string"
        ) {
          // 顧客情報の画像変更
          const editValue = editDataContractCustomerInfo.editValue as {
            [key: string]: string | string[];
          };
          let customer_info = { ...editValue };

          const fileName = editDataContractCustomerInfo.customer_picture.name;
          const date = new Date();
          const year = date.getFullYear();
          const month = String(date.getMonth() + 1).padStart(2, "0"); // 月は0始まりのため+1
          const day = String(date.getDate()).padStart(2, "0");
          const hours = String(date.getHours()).padStart(2, "0");
          const minutes = String(date.getMinutes()).padStart(2, "0");
          const seconds = String(date.getSeconds()).padStart(2, "0");
          const nowTimeName = `${year}${month}${day}${hours}${minutes}${seconds}`;
          const { presigned_object, destination_key } =
            await getPresignedPostPicture(nowTimeName, fileName);
          // POSTする form に持たせるデータを生成する
          const formData = new FormData();
          for (const key in presigned_object.fields) {
            formData.append(key, presigned_object.fields[key]);
          }
          formData.append(
            "file",
            editDataContractCustomerInfo.customer_picture,
          );
          // ファイルをS3にアップロード
          await postPresignedPost(presigned_object.url, formData);
          customer_info[editDataContractCustomerInfo.key] = destination_key;
          const _editDataContractCustomerInfo = {
            ...editDataContractCustomerInfo,
            editValue: customer_info,
          };
          const putResponce = await putContractCustomerInfo(
            _editDataContractCustomerInfo,
          );
          await getTableData(true);
          await getSubtableDataContractCustomerInfo();
          setEditDataContractCustomerInfo({
            ..._editDataContractCustomerInfo,
            status: putResponce,
          });
        }
      } else {
        const putResponce = await putContractCustomerInfo(
          editDataContractCustomerInfo,
        );
        if (putResponce == "success") {
          await getTableData(true);
          await getSubtableDataContractCustomerInfo();
        }
        setEditDataContractCustomerInfo({
          ...editDataContractCustomerInfo,
          status: putResponce,
        });
      }
      setIsLoading(false);
    }
  }

  // 契約情報一覧取得
  async function getSubtableDataContractContractInfo() {
    if (getSubTableName.key.id) {
      setIsLoading(true);
      const fetchData = await getContractContractInfos(getSubTableName.key.id);
      const contractInfo = fetchData.sudDatas[0].contract_info as {
        [key: string]: string;
      };
      const contractInfoKeys = Object.keys(contractInfo);
      const subData = contractInfoKeys.map((key) => {
        return {
          contract_info_key: key,
          contract_info_value: contractInfo[key],
        };
      });
      setGetSubTableName({
        ...getSubTableName,
        subData,
      });
      setIsLoading(false);
    }
  }

  // 契約情報項目削除
  const [deleteContractInfoDataInf, setDeleteContractInfoDataInf] = useState<{
    status: null | "loading" | "open" | "success" | "failed";
    key: { [key: string]: string };
    message: string;
  }>({
    status: null,
    key: {},
    message: "",
  });
  async function deleteContractInfoData() {
    setDeleteContractInfoDataInf({
      ...deleteContractInfoDataInf,
      status: "loading",
    });
    const responce = await deleteContractContractInfo(
      getSubTableName.key.id,
      deleteContractInfoDataInf.key.infoKey
    );
    if (responce === "success") {
      await getTableData(false);
      await getSubtableDataContractContractInfo();
      setDeleteContractInfoDataInf({
        ...deleteContractInfoDataInf,
        status: "success",
      });
    } else {
      setDeleteContractInfoDataInf({
        ...deleteContractInfoDataInf,
        status: "failed",
        message: responce,
      });
    }
  }
  useEffect(() => {
    if (deleteContractInfoDataInf.status === "loading") {
      setIsLoading(true);
    } else if (deleteContractInfoDataInf.status !== null) {
      setIsLoading(false);
    }
  }, [deleteContractInfoDataInf]);

  // カテゴリ一覧
  const [categoryList, setCategoryList] = useState<
    { id: number; category_name: string }[]
  >([]);
  const [categoryNameList, setCategoryNameList] = useState([""]);
  async function getCategoryList() {
    const fetchData = await getSerchCategorys();
    if (fetchData === null) {
      setCategoryList([]);
    } else if (fetchData) {
      setCategoryList(
        fetchData.categorys as {
          id: number;
          category_name: string;
        }[],
      );
      let categoryNameList = [""];
      fetchData.categorys.map(
        (company: { id: number; category_name: string }) => {
          if (!categoryNameList.includes(company.category_name)) {
            categoryNameList.push(company.category_name);
          }
        },
      );
      setCategoryNameList(categoryNameList);
    }
  }

  // 上位店一覧
  const [highRankCompanyList, setHighRankCompanyList] = useState<
    { id: number; high_rank_company_name: string }[]
  >([]);
  const [highRankCompanyNameList, setHighRankCompanyNameList] = useState([""]);
  // 上位店一覧取得
  async function getHighRankCompanyList() {
    const fetchData = await getSerchHighRankCompanys();
    if (fetchData === null) {
      setHighRankCompanyList([]);
    } else if (fetchData) {
      setHighRankCompanyList(
        fetchData.highRankCompanys as {
          id: number;
          high_rank_company_name: string;
        }[],
      );
      let highRankCompanyNameList = [""];
      fetchData.highRankCompanys.map(
        (company: { id: number; high_rank_company_name: string }) => {
          if (
            !highRankCompanyNameList.includes(company.high_rank_company_name)
          ) {
            highRankCompanyNameList.push(company.high_rank_company_name);
          }
        },
      );
      setHighRankCompanyNameList(highRankCompanyNameList);
    }
  }

  // パートナー一覧
  const [companyList, setCampanyList] = useState<
    { id: number; sale_company_name: string }[]
  >([]);
  const [companyNameList, setCampanyNameList] = useState([""]);
  // パートナー一覧取得
  async function getSaleCompanysList() {
    const fetchData = await getSerchSaleCompanys();
    if (fetchData === null) {
      setCampanyList([]);
    } else if (fetchData) {
      setCampanyList(
        fetchData.saleCompanys as { id: number; sale_company_name: string }[],
      );
      let companyNameList = [""];
      fetchData.saleCompanys.map(
        (company: { id: number; sale_company_name: string }) => {
          if (!companyNameList.includes(company.sale_company_name)) {
            companyNameList.push(company.sale_company_name);
          }
        },
      );
      setCampanyNameList(companyNameList);
    }
  }
  // 商材一覧
  const [productList, setProductList] = useState<
    {
      id: number;
      high_rank_company_id: number;
      product_name: string;
      high_rank_company_name: string;
      product_key: string;
    }[]
  >([]);
  const [productNameList, setProductNameList] = useState([""]);
  async function getProductList() {
    const fetchData = await getSerchProducts();
    if (fetchData === null) {
      setProductList([]);
    } else if (fetchData) {
      setProductList(
        fetchData.products as {
          id: number;
          high_rank_company_id: number;
          product_name: string;
          high_rank_company_name: string;
          product_key: string;
        }[],
      );
    }
  }
  async function getProductNameListFromHistory() {
    const products = await getProductCandidatesEntry();
    if (products) {
      const names: string[] = [""];
      for (const p of products) {
        if (p.product_name && !names.includes(p.product_name)) {
          names.push(p.product_name);
        }
      }
      setProductNameList(names);
    }
  }

  // グループ一覧取得
  const [searchGroupList, setSearchGroupList] = useState<
    {
      id: number;
      group_name: string;
      sale_company_id: number;
    }[]
  >([]);
  const [searchGroupNameList, setSearchGroupNameList] = useState([""]);
  async function getSaleCompanyGroupsList() {
    const fetchData = await getSerchSaleCompanyGroups();
    if (fetchData === null) {
      setSearchGroupList([]);
    } else if (fetchData) {
      setSearchGroupList(
        fetchData.saleCompanyGroups as {
          id: number;
          group_name: string;
          sale_company_id: number;
        }[],
      );
      let searchGroupNameList = [""];
      fetchData.saleCompanyGroups.map(
        (company: { id: number; group_name: string }) => {
          if (!searchGroupNameList.includes(company.group_name)) {
            searchGroupNameList.push(company.group_name);
          }
        },
      );
      setSearchGroupNameList(searchGroupNameList);
    }
  }

  // 営業アカウント一覧
  const [accountSaleList, setAccountSaleList] = useState<
    { id: number; account_name: string }[]
  >([]);
  const [accountSaleNameList, setAccountSaleNameList] = useState([""]);
  async function getSaleAccountSalesList() {
    const fetchData = await getSerchAccountSales();
    if (fetchData === null) {
      setAccountSaleList([]);
    } else if (fetchData) {
      setAccountSaleList(
        fetchData.accountSales as { id: number; account_name: string }[],
      );
      let accountSaleNameList = [""];
      fetchData.accountSales.map(
        (accountSale: { id: number; account_name: string }) => {
          if (!accountSaleNameList.includes(accountSale.account_name)) {
            accountSaleNameList.push(accountSale.account_name);
          }
        },
      );
      setAccountSaleNameList(accountSaleNameList);
    }
  }
  // 協業営業アカウント一覧
  const [
    accountCollaborateCompanySaleList,
    setAccountCollaborateCompanySaleList,
  ] = useState<
    {
      sale_company_id: number;
      sale_company_name: string;
      id: number;
      account_name: string;
    }[]
  >([]);
  const [
    accountCollaborateCompanySaleNameList,
    setAccountCollaborateCompanySaleNameList,
  ] = useState([""]);
  async function getCollaborateCompanySaleAccountSalesList() {
    const fetchData = await getSerchAccountCollaborateCompanys();
    if (fetchData === null) {
      setAccountCollaborateCompanySaleList([]);
    } else if (fetchData) {
      setAccountCollaborateCompanySaleList(
        fetchData.accountCollaborateCompanySales as {
          sale_company_id: number;
          sale_company_name: string;
          id: number;
          account_name: string;
        }[],
      );
      let accountSaleNameList = [""];
      fetchData.accountCollaborateCompanySales.map(
        (accountSale: {
          sale_company_id: number;
          sale_company_name: string;
          id: number;
          account_name: string;
        }) => {
          if (!accountSaleNameList.includes(accountSale.account_name)) {
            accountSaleNameList.push(accountSale.account_name);
          }
        },
      );
      setAccountCollaborateCompanySaleNameList(accountSaleNameList);
    }
  }
  useEffect(() => {
    getHighRankCompanyList();
    getCategoryList();
    getSaleCompanysList();
    getSaleCompanyGroupsList();
    getProductList();
    getProductNameListFromHistory();
    getSaleAccountSalesList();
    getCollaborateCompanySaleAccountSalesList();
  }, []);

  const handleSetSerchOpen = (open: boolean) => {
    setSerchOpen(open);
    if (open) setAiChatOpen(false);
  };
  const handleSetAiChatOpen = (open: boolean) => {
    setAiChatOpen(open);
    if (open) setSerchOpen(false);
  };

  return (
    <Box
      data-testid="contract-page"
      style={{
        width: isSmartPhone
          ? "calc(100% - 31px)"
          : serchOpen || aiChatOpen
            ? "calc(100% - 331px)"
            : "calc(100% - 31px)",
        height: isSmartPhone ? "calc(100vh - 120px)" : "calc(100vh - 40px)",
      }}
    >
      {(loginUser?.authority === "パートナー" ||
        loginUser?.authority === "営業アカウント") &&
      !serchOpen &&
      !aiChatOpen ? (
        <>
          <IconButton
            size="small"
            aria-label="account of current user"
            aria-controls="menu-appbar"
            aria-haspopup="true"
            color="default"
            sx={{
              position: "fixed",
              bottom: "5px",
              right: "5px",
              zIndex: 1,
            }}
          >
            <CircleIcon
              fontSize="large"
              sx={{
                color: "white",
                width: "65px",
                height: "65px",
              }}
            />
          </IconButton>
          <IconButton
            size="small"
            aria-label="account of current user"
            aria-controls="menu-appbar"
            aria-haspopup="true"
            color="default"
            onClick={() => setAddDataName("エントリー")}
            sx={{
              position: "fixed",
              bottom: "5px",
              right: "5px",
              zIndex: 1,
            }}
          >
            <AddCircleIcon
              fontSize="large"
              sx={{
                color: "primary.dark",
                width: "65px",
                height: "65px",
              }}
            />
          </IconButton>
        </>
      ) : null}
      <TableTopBar
        serch={true}
        serchOpen={serchOpen}
        setSerchOpen={handleSetSerchOpen}
        addDataNames={addDataNames}
        addDataName={addDataName}
        setAddDataName={setAddDataName}
        addCSVDataNames={addCSVDataNames}
        addCSVDataName={addCSVDataName}
        setAddCSVDataName={setAddCSVDataName}
        getXLSXDataNames={getXLSXDataNames}
        getXLSXDataName={getXLSXDataName}
        setGetXLSXDataName={setGetXLSXDataName}
        editDatasNames={editDatasNames}
        editDatasName={editDatasName}
        setEditDatasName={setEditDatasName}
        editIDs={[]}
        columnSettingOpen={columnSetting.status !== "none"}
        openColumnSettingWindow={openColumnSettingWindow}
        aiChatOpen={aiChatOpen}
        setAiChatOpen={handleSetAiChatOpen}
      />
      <Box style={{ display: "flex" }}>
        {(serchOpen || aiChatOpen) && isSmartPhone ? null : (
          <Box
            style={{
              width: isSmartPhone ? undefined : "100%",
              margin: isSmartPhone ? undefined : "10px 15px",
              height: isSmartPhone ? undefined : tableHeight,
              maxHeight: isSmartPhone ? undefined : tableHeight,
            }}
          >
            <ConstTable
              getTableData={getTableData}
              tableType={"main"}
              serchOpen={serchOpen}
              aiChatOpen={aiChatOpen}
              tableHeight={tableHeight}
              tableColumn={contractTableColumn}
              dataColumn={contractScreenColumn}
              rows={fetchData}
              displayNumber={displayNumber}
              setDisplayNumber={setDisplayNumber}
              displayNumbers={displayNumbers}
              pageNumber={pageNumber}
              setPageNumber={setPageNumber}
              maxPageNumber={maxPageNumber}
              totalCount={totalCount}
              getDataDetail={getDataDetail}
              getSubTableName={getSubTableName}
              setGetSubTableName={setGetSubTableName}
              getSubTableDetail={{
                name: "",
                key: {},
                dataDetail: null,
              }}
              setGetSubTableDetail={() => {}}
              setGetSubTableAdd={() => {}}
              setGetSubTableEditDirect={setEditDataContractCustomerInfo}
              getSubSubTableName={{
                name: "",
                key: {},
                subData: [],
              }}
              setGetSubSubTableName={() => {}}
              getSubSubTableDetail={{
                name: "",
                key: {},
                dataDetail: null,
              }}
              setGetSubSubTableDetail={() => {}}
              setGetSubSubTableAdd={() => {}}
              setGetSubSubTableEditDirect={() => {}}
              tableTitle={contractTableColumn.title}
              switchTableCheckBox={() => {}}
              allCheckFlg={false}
              switchAllTableCheckBox={() => {}}
              editIDs={[]}
              setEditIDs={() => {}}
              setEditDatasName={setEditDatasName}
              setGetSubMainTableName={() => {}}
              setTableOriginalFunc={setTableOriginalFunc}
              sortColumn={sortColumn}
              setSortColumn={setSortColumn}
            />
          </Box>
        )}
        {serchOpen ? (
          <SerchSideBar
            setSerchOpen={handleSetSerchOpen}
            tableHeight={tableHeight}
            tableColumn={contractTableColumn}
            dataColumn={contractScreenColumn}
            firstYear={firstYear}
            thisYear={thisYear}
            serchColumn={serchColumn}
            setSerchString={setSerchString}
            companyNameList={companyNameList}
            companyGroupNameList={searchGroupNameList}
            highRankCompanyNameList={highRankCompanyNameList}
            categoryNameList={categoryNameList}
            productNameList={productNameList}
            accountSaleNameList={accountSaleNameList}
            accountStaffNameList={[]}
            serchStringView={serchStringView}
            setSerchStringView={setSerchStringView}
          />
        ) : null}
        {aiChatOpen && (
          <AiChatSideBar
            open={aiChatOpen}
            setOpen={handleSetAiChatOpen}
            pageName="Contract"
          />
        )}
      </Box>
      <DataDetailModal
        onModal={
          dataDetail !== null &&
          dataDetail.contract_version !== null &&
          ((editData !== null && editData.status !== "editing") ||
            editData === null)
        }
        swCloseModal={() => setDataDetail(null)}
        detailTitle={contractTableColumn.detailTitle}
        editAuth={contractTableColumn.editAuth}
        dataColumn={contractScreenColumn}
        subDataColumn={[]}
        dataDetail={dataDetail}
        setEditData={setEditData}
        option={false}
        setEditProduct={() => {}}
        dataDetailOption={dataDetailOption}
        dataDetailOptionSelect={[]}
        dataDetailHistory={dataDetailHistory}
        selectHistory={selectHistory}
        getOldDataDetail={getOldDataDetail}
        getGroupList={() => {}}
        setEditProductOptionPlans={() => {}}
        setEditProductOptionContents={() => {}}
        setEditTossUpFormOptionProducts={() => {}}
        setEditOutsideServices={() => {}}
        setSelectServiseInfo={setSelectServiseInfo}
        setSelectTossUpInfo={() => {}}
      />
      <DataEditModal
        onModal={editData !== null && editData.status !== "editing"}
        swCloseModal={() => {
          setEditData(null);
          setSelectServiseInfo({
            service_plan_data: [],
            service_content_data: [],
            service_campaign_pulldown_data: [],
            service_campaign_checkbox_data: [],
          });
        }}
        editData={editData}
        setEditData={setEditData}
        putEditData={putEditData}
        groupList={[]}
        categoryList={[]}
        accountCollaborateCompanySaleList={accountCollaborateCompanySaleList}
        selectServiseInfo={selectServiseInfo}
        selectTossUpInfo={{
          tossUpCategoryNameList: [],
          tossUpProductNameList: [],
        }}
      />
      <DataEditModal
        onModal={
          editDataContractCustomerInfo !== null &&
          editDataContractCustomerInfo.status !== "editing"
        }
        swCloseModal={() => setEditDataContractCustomerInfo(null)}
        editData={editDataContractCustomerInfo}
        setEditData={setEditDataContractCustomerInfo}
        putEditData={putEditSubtableDataDirectContractCustomerInfo}
        groupList={[]}
        categoryList={[]}
        accountCollaborateCompanySaleList={[]}
        selectServiseInfo={{
          service_plan_data: [],
          service_content_data: [],
          service_campaign_pulldown_data: [],
          service_campaign_checkbox_data: [],
        }}
        selectTossUpInfo={{
          tossUpCategoryNameList: [],
          tossUpProductNameList: [],
        }}
      />
      <ChangeAccountCollaborateModal
        onModal={addData.addStatus === "change_account"}
        swCloseModal={() => {
          closeAddModal();
          setAddDataName("");
        }}
        changeAccount={addData.changeAccount}
        changeAccountID={addData.changeAccountID}
        setChangeAccount={(changeAccount: 0 | 1) =>
          setAddData({
            ...addData,
            changeAccount,
          })
        }
        setChangeAccountID={(changeAccountID: number | null) =>
          setAddData({
            ...addData,
            changeAccountID,
          })
        }
        accountCollaborateCompanySaleList={accountCollaborateCompanySaleList}
        title={"エントリー"}
        getFormFunction={getContractProductList}
        accountColumn={"営業担当アカウント"}
      />
      <ContractAddModal
        onModal={
          addData.addStatus !== null &&
          addData.addStatus !== "loading" &&
          addData.addStatus !== "change_account"
        }
        swCloseModal={() => {
          closeAddModal();
          setAddDataName("");
        }}
        tableColumn={contractTableColumn}
        postAddData={postAddData}
        addData={addData}
        setAddData={setAddData}
        contractProductList={contractProductList}
        firstYear={firstYear}
        thisYear={thisYear}
        selectServisePlanList={selectServisePlanList}
        setSelectServisePlanList={setSelectServisePlanList}
        selectServiseContentList={selectServiseContentList}
        setSelectServiseContentList={setSelectServiseContentList}
        selectServiseCampaignPulldownList={selectServiseCampaignPulldownList}
        setSelectServiseCampaignPulldownList={
          setSelectServiseCampaignPulldownList
        }
        selectServiseCampaignCheckboxList={selectServiseCampaignCheckboxList}
        setSelectServiseCampaignCheckboxList={
          setSelectServiseCampaignCheckboxList
        }
        selectServisePaymentList={selectServisePaymentList}
        setSelectServisePaymentList={setSelectServisePaymentList}
        uniqueOptinList={uniqueOptinList}
        setUniqueOptinList={setUniqueOptinList}
        addressOptionName={addressOptionName}
        setAddressOptionName={setAddressOptionName}
        postPictures={postPictures}
        setPostPicture={setPostPicture}
        setOnDataAddModalResult={setOnDataAddModalResult}
      />
      <DataAddModalResult
        onModal={onDataAddModalResult !== ""}
        swCloseModal={() => {
          setOnDataAddModalResult("");
          setAddDataName("");
        }}
        addModalTitle={"新規作成"}
        onDataAddModalResult={onDataAddModalResult}
      />
      <PostCSVContractStatusModal
        onModal={
          postCSVStatus.status !== "none" && postCSVStatus.status !== "loading"
        }
        swCloseModal={() => {
          setPostCSVStatus({
            status: "none",
            message: "",
            result: [],
            header_location: "None",
            destination_key: "",
            product_id: null,
            product_key: "",
            header_inf: {},
          });
          setAddCSVDataName("");
          setPostCSVStatusHeader([]);
        }}
        postCSVStatus={postCSVStatus}
        setPostCSVStatus={setPostCSVStatus}
        postCSVFunc={postContractStatusCSV}
        startPutCSVFunc={startPutContractStatusCSV}
        postCSVTitle={contractTableColumn.postCSVTitle}
        productList={productList}
        postCSVStatusHeader={postCSVStatusHeader}
      />
      <PostCSVModal
        onModal={
          putCSVContractService.status !== "none" &&
          putCSVContractService.status !== "loading"
        }
        swCloseModal={() => {
          setPutCSVContractService({
            status: "none",
            message: "",
            result: [],
            header_location: "None",
          });
          setAddCSVDataName("");
        }}
        postCSVStatus={putCSVContractService}
        setPostCSVStatus={setPutCSVContractService}
        postCSVFunc={putContractServiceCSV}
        postCSVTitle={"契約サービスCSV更新取込"}
        postCSVColumn={putCSVColumnContractService}
        postCSVColumnResult={putCSVColumnContractServiceResult}
        postCSVPath="contractService"
        productList={[]}
        categoryList={[]}
      />
      <PostCSVModal
        onModal={
          postCSVSaleAccount.status !== "none" &&
          postCSVSaleAccount.status !== "loading"
        }
        swCloseModal={() => {
          setPostCSVSaleAccount({
            status: "none",
            message: "",
            result: [],
            header_location: "None",
          });
          setAddCSVDataName("");
        }}
        postCSVStatus={postCSVSaleAccount}
        setPostCSVStatus={setPostCSVSaleAccount}
        postCSVFunc={postContractSaleAccountCSV}
        postCSVTitle={"営業アカウント更新CSV取込"}
        postCSVColumn={putCSVColumnSaleAccount}
        postCSVColumnResult={putCSVColumnSaleAccount}
        postCSVPath="contractSaleAccount"
        productList={[]}
        categoryList={[]}
      />
      <PostCSVModal
        onModal={
          postCSVContractNumber.status !== "none" &&
          postCSVContractNumber.status !== "loading"
        }
        swCloseModal={() => {
          setPostCSVContractNumber({
            status: "none",
            message: "",
            result: [],
            header_location: "None",
          });
          setAddCSVDataName("");
        }}
        postCSVStatus={postCSVContractNumber}
        setPostCSVStatus={setPostCSVContractNumber}
        postCSVFunc={postContractNumberCSV}
        postCSVTitle={"申込番号CSV取込"}
        postCSVColumn={putCSVColumnContractNumber}
        postCSVColumnResult={putCSVColumnContractNumber}
        postCSVPath="contractNumber"
        productList={[]}
        categoryList={[]}
      />
      <PostCSVModal
        onModal={
          postContractCSVStatus.status !== "none" &&
          postContractCSVStatus.status !== "loading"
        }
        swCloseModal={() => {
          setPostContractCSVStatus({
            status: "none",
            message: "",
            result: [],
            header_location: "None",
          });
          setAddCSVDataName("");
        }}
        postCSVStatus={postContractCSVStatus}
        setPostCSVStatus={setPostContractCSVStatus}
        postCSVFunc={postContractCSV}
        postCSVTitle={"契約情報事前取込"}
        postCSVColumn={postCSVColumnAdminContract}
        postCSVColumnResult={postCSVColumnAdminContractResult}
        postCSVPath="addContract"
        productList={productList}
        categoryList={[]}
      />
      <PostCSVModal
        onModal={
          postEntryContractCSVStatus.status !== "none" &&
          postEntryContractCSVStatus.status !== "loading"
        }
        swCloseModal={() => {
          setPostEntryContractCSVStatus({
            status: "none",
            message: "",
            result: [],
            header_location: "None",
          });
          setAddCSVDataName("");
        }}
        postCSVStatus={postEntryContractCSVStatus}
        setPostCSVStatus={setPostEntryContractCSVStatus}
        postCSVFunc={postEntryContractCSV}
        postCSVTitle={"CSV一括エントリー"}
        postCSVColumn={postCSVColumnEntryContract}
        postCSVColumnResult={postCSVColumnEntryContractResult}
        postCSVPath="entryContract"
        productList={productList}
        categoryList={[]}
      />
      <GetXLSXContractModal
        onModal={getXLSXStatus.status !== "none"}
        swCloseModal={() => {
          setGetXLSXStatus({
            status: "none",
            message: "",
            contract_state: "",
            sale_company_id: null,
            sale_company_name: "",
            all_company: false,
            product_ids: [],
            product_names: [],
            all_product: false,
            merge_sheet: false,
            post_start_year: lastYear.toString(),
            post_start_month: lastMonth.toString(),
            post_end_year: thisYear.toString(),
            post_end_month: thisMonth.toString(),
            post_all_year: false,
            apply_start_year: lastYear.toString(),
            apply_start_month: lastMonth.toString(),
            apply_end_year: thisYear.toString(),
            apply_end_month: thisMonth.toString(),
            apply_all_year: true,
            opening_start_year: lastYear.toString(),
            opening_start_month: lastMonth.toString(),
            opening_end_year: thisYear.toString(),
            opening_end_month: thisMonth.toString(),
            opening_all_year: true,
            cancell_start_year: lastYear.toString(),
            cancell_start_month: lastMonth.toString(),
            cancell_end_year: thisYear.toString(),
            cancell_end_month: thisMonth.toString(),
            cancell_all_year: true,
          });
          setGetXLSXDataName("");
        }}
        getXLSXStatus={getXLSXStatus}
        setGetXLSXStatus={setGetXLSXStatus}
        getXLSXFunc={getPaymentsXLSX}
        firstYear={firstYear}
        thisYear={thisYear}
        thisMonth={thisMonth}
        lastYear={lastYear}
        lastMonth={lastMonth}
        companyList={companyList}
        productList={productList}
      />
      <DataDeleteModal
        onModal={
          deleteDataInf.status !== null && deleteDataInf.status !== "loading"
        }
        swCloseModal={() => {
          setDeleteDataInf({
            status: null,
            key: {},
            message: "",
          });
          setTableOriginalFunc({
            name: "",
            key: {},
          });
        }}
        deleteDataInf={deleteDataInf}
        setDeleteDataInf={setDeleteDataInf}
        deleteData={deleteData}
        labels={{
          title: "エントリー取消",
          confirmBody: (
            <Alert severity="error">
              エントリー取消後、データは復元できません。
              <br />
              誤って登録をしたエントリーのみ取消を実施してください。
            </Alert>
          ),
          confirmButtonLabel: "エントリー取消",
          successMessage: "エントリーの削除に成功しました。",
        }}
      />
      <DataDeleteModal
        onModal={
          deleteContractInfoDataInf.status !== null &&
          deleteContractInfoDataInf.status !== "loading"
        }
        swCloseModal={() => {
          setDeleteContractInfoDataInf({
            status: null,
            key: {},
            message: "",
          });
          setTableOriginalFunc({ name: "", key: {} });
        }}
        deleteDataInf={deleteContractInfoDataInf}
        setDeleteDataInf={setDeleteContractInfoDataInf}
        deleteData={deleteContractInfoData}
        labels={{
          title: "契約情報項目の削除",
          confirmBody: (
            <Alert severity="error">
              項目「{deleteContractInfoDataInf.key.infoKey}」を削除します。削除後、データは復元できません。
            </Alert>
          ),
          confirmButtonLabel: "削除",
          successMessage: "契約情報項目の削除に成功しました。",
        }}
      />
      <PersonDataDeleteModal
        onModal={
          deletePersonDataInf.status !== null &&
          deletePersonDataInf.status !== "loading"
        }
        swCloseModal={() => {
          setDeletePersonDataInf({
            status: null,
            key: {},
            message: "",
          });
          setTableOriginalFunc({
            name: "",
            key: {},
          });
        }}
        deletePersonDataInf={deletePersonDataInf}
        setDeletePersonDataInf={setDeletePersonDataInf}
        deletePersonData={deletePersonData}
      />
      <DataCancelModal
        onModal={
          cancelDataInf.status !== null && cancelDataInf.status !== "loading"
        }
        swCloseModal={() => {
          setCancelDataInf({
            status: null,
            key: {},
            message: "",
            cancellAction: "",
            cancellSmsList: [],
            selectedCancellSms: null,
            destinationPhoneNumber: "",
            destinationMailAddress: "",
          });
          setTableOriginalFunc({
            name: "",
            key: {},
          });
        }}
        cancelDataInf={cancelDataInf}
        setCancelDataInf={setCancelDataInf}
        cancelData={cancelData}
      />
      <ChangeAccountCollaborateModal
        onModal={entryToTossUpDataInf.addStatus === "change_account"}
        swCloseModal={() => {
          closeEntryToTossUpModal();
          setTableOriginalFunc({
            name: "",
            key: {},
          });
        }}
        changeAccount={entryToTossUpDataInf.changeAccount}
        changeAccountID={entryToTossUpDataInf.changeAccountID}
        setChangeAccount={(changeAccount: 0 | 1) =>
          setEntryToTossUpDataInf({
            ...entryToTossUpDataInf,
            changeAccount,
          })
        }
        setChangeAccountID={(changeAccountID: number | null) =>
          setEntryToTossUpDataInf({
            ...entryToTossUpDataInf,
            changeAccountID,
          })
        }
        accountCollaborateCompanySaleList={accountCollaborateCompanySaleList}
        title={"トスアップ複製"}
        getFormFunction={openEntryToTossUp}
        accountColumn={"トスアップアカウント"}
      />
      <ContractCopyTossUpModal
        onModal={
          entryToTossUpDataInf.addStatus !== null &&
          entryToTossUpDataInf.addStatus !== "loading" &&
          entryToTossUpDataInf.addStatus !== "change_account"
        }
        swCloseModal={() => {
          closeEntryToTossUpModal();
          setTableOriginalFunc({
            name: "",
            key: {},
          });
        }}
        postAddData={postEntryToTossUpData}
        addData={entryToTossUpDataInf}
        setAddData={setEntryToTossUpDataInf}
        uniqueOptinList={entryToTossUpUniqueOptinList}
        setUniqueOptinList={setEntryToTossUpUniqueOptinList}
        addressOptionName={entryToTossUpAddressOptionName}
        setAddressOptionName={setEntryToTossUpAddressOptionName}
        postPictures={entryToTossUpPostPictures}
        setPostPicture={setEntryToTossUpPostPicture}
        tossUpCategoryNameList={tossUpCategoryNameList}
        tossUpProductNameList={tossUpProductNameList}
        setOnDataAddModalResult={setOnDataAddModalResult}
      />
      <ContractCopyEntryModal
        entryToEntryDataInf={entryToEntryDataInf}
        setEntryToEntryDataInf={setEntryToEntryDataInf}
        closeEntryToEntryModal={closeEntryToEntryModal}
        customerInfo={customerInfo}
        setCustomerInfo={setCustomerInfo}
        addData={entryToEntryAddData}
        setAddData={setEntryToEntryAddData}
        addressOptionName={entryToEntryAddressOptionName}
        setAddressOptionName={setEntryToEntryAddressOptionName}
        selectServisePlanList={entryToEntrySelectServisePlanList}
        setSelectServisePlanList={setEntryToEntrySelectServisePlanList}
        selectServiseContentList={entryToEntrySelectServiseContentList}
        setSelectServiseContentList={setEntryToEntrySelectServiseContentList}
        selectServiseCampaignPulldownList={
          entryToEntrySelectServiseCampaignPulldownList
        }
        setSelectServiseCampaignPulldownList={
          setEntryToEntrySelectServiseCampaignPulldownList
        }
        selectServiseCampaignCheckboxList={
          entryToEntrySelectServiseCampaignCheckboxList
        }
        setSelectServiseCampaignCheckboxList={
          setEntryToEntrySelectServiseCampaignCheckboxList
        }
        selectServisePaymentList={entryToEntrySelectServisePaymentList}
        setSelectServisePaymentList={setEntryToEntrySelectServisePaymentList}
        uniqueOptinList={entryToEntryUniqueOptinList}
        setUniqueOptinList={setEntryToEntryUniqueOptinList}
        postPictures={entryToEntryPostPictures}
        setPostPictures={setEntryToEntryPostPictures}
        onPostButton={onPostButton}
        setOnPostButton={setOnPostButton}
        selectedProductId={selectedProductId}
        setSelectedProductId={setSelectedProductId}
        selectedProductName={selectedProductName}
        setSelectedProductName={setSelectedProductName}
        setOnDataAddModalResult={setOnDataAddModalResult}
      />
      <ChangeAccountCollaborateModal
        onModal={entryToEntryDataInf.addStatus === "change_account"}
        swCloseModal={closeEntryToEntryModal}
        changeAccount={entryToEntryDataInf.changeAccount as 0 | 1}
        changeAccountID={entryToEntryDataInf.changeAccountID}
        setChangeAccount={(changeAccount: 0 | 1) =>
          setEntryToEntryDataInf({
            ...entryToEntryDataInf,
            changeAccount,
          })
        }
        setChangeAccountID={(changeAccountID: number | null) =>
          setEntryToEntryDataInf({
            ...entryToEntryDataInf,
            changeAccountID,
          })
        }
        accountCollaborateCompanySaleList={accountCollaborateCompanySaleList}
        title={"エントリー複製"}
        getFormFunction={() => {
          openEntryToEntryData(
            entryToEntryDataInf.contractId,
            entryToEntryDataInf.changeAccount,
            entryToEntryDataInf.changeAccountID,
          );
        }}
        accountColumn={"営業担当アカウント"}
      />
      <ColumnSettingModal
        onModal={
          columnSetting.status !== "none" && columnSetting.status !== "loading"
        }
        swCloseModal={closeColumnSettingModal}
        columnSetting={columnSetting}
        setColumnSetting={setColumnSetting}
        putClumnSetting={putClumnSetting}
      />
    </Box>
  );
}

export default Contract;
